import Constant from '@/common/constant/Constant';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import Utils from '@/common/utils/utils';
import { cloneDeep } from 'lodash';
import { getDrilldownData, getPublicRangeData, searchTicketKnowledge } from '@/service/ticketKnowledgeService';
import { getDrilldownDataSelected } from '@/component/ticketList/handler/KnowledgeTicketHandler'
import {
    getProjectById,
    getProjectUserInUseDetail,
    getInitOrganizationDataInKnowledgePanel
} from '@/service/projectService';
import { getCorporationById } from '@/service/organizationService';
import moment from 'moment';
import {
    getChildNameInDrillDown,
    getPublicRangeName,
    getSystemFieldNameInDrillDown,
    isSelectedOption
} from './DrilldownAndDetailSearchHandler';
import {
    processDrillDownDataSuffixOfAttachments,
    processDrillDownDataUser,
    sortFormInDrilldown
} from '@/component/ticketList/handler/HelpDeskTicketListHandler';
import LogKibanaConstant from '@/common/constant/LogKibanaConstant';
import { createKibanaData } from '@/component/system/logKibanaHandler/LogKibanaHandler';
import {  API, I18n } from 'aws-amplify';
import localStorageUtil from '@/common/utils/localStorageUtil';
import ListTicketKnowledgeConstant from '@/common/constant/ListTicketKnowledgeConstant';
import { handleBulkUpdateTicket, queryListMasterKnowledgeItemWithShortenedData } from '@/service/ticketService';
import { getFormById, getListFieldInFieldByFormId, queryTagChildWithShortenedData } from '@/service/formManagementService';
import { getBookmarkAPI, updateBookmarkAPI } from '@/service/bookmarkService';
import _ from "lodash";
import { IgnoreBulkActionField, AutoPassForBulkAction } from '@/common/constant/SystemField';
import TelephoneConstant from '@/common/constant/TelephoneConstant';

const TagSysFieldPriority = [
    Constant.AI_AUTO.SYSTEM_FIELD.CHATGPT_MODEL,
    Constant.AI_PROMPT.APPLY_AI_PROMPT,
    Constant.AI_PROMPT.AI_PROMPT_APPLICATION_TARGET,
    Constant.SYSTEM_FIELD.AI_BASIC_INFO_TRANSMISSION,
    Constant.AI_AUTO.SYSTEM_FIELD.TICKET_TYPE_ACTIVE,
    Constant.AI_AUTO.SYSTEM_FIELD.FORM_ACTIVE,
    Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER,
    Constant.AI_AUTO.SYSTEM_FIELD.HOURS_EXECUTE,
    Constant.AI_AUTO.SYSTEM_FIELD.MINUTES_EXECUTE,
    Constant.SYSTEM_FIELD.AI_PDF_PAGE_SPLIT_STATUS,
    Constant.AI_AUTO.SYSTEM_FIELD.CHAT_THREAD_TYPE_TRIGGER,
    Constant.SD_AUTO.SYSTEM_FIELD.SDAUTO_AS_TOOL_CALL
]

/**
 * buildDrillDownSearchParam for list knowledge and drilldown list
 * @param {*} viewStructure
 * @returns
 */
export const buildDrillDownSearchParam = viewStructure => {
    let objDrillDownSearch = {
        tagFields: [],
        statusFields: []
    };

    if (!viewStructure || Utils.isEmptyObject(viewStructure)) {
        return objDrillDownSearch;
    }

    if (!Utils.isEmptyArray(viewStructure.fields)) {
        let listAttachments = [];
        viewStructure.fields.forEach(systemFieldData => {
            if (!Utils.isEmptyArray(Object.keys(systemFieldData))) {
                let systemFieldId = Object.keys(systemFieldData)[0];
                if (systemFieldId !== 'suffixOfAttachments') {
                    objDrillDownSearch[systemFieldId] = systemFieldData[systemFieldId];
                } else {
                    listAttachments.push(systemFieldData[systemFieldId]);
                }
            }
        });

        if (!Utils.isEmptyArray(listAttachments)) {
            objDrillDownSearch['suffixOfAttachments'] = listAttachments;
        }
    }

    if (!Utils.isEmptyArray(viewStructure.tagFields)) {
        viewStructure.tagFields.forEach(tagFieldData => {
            if (!Utils.isEmptyArray(Object.keys(tagFieldData))) {
                let tagFieldId = Object.keys(tagFieldData)[0];
                let tagItemId = tagFieldData[tagFieldId];

                if (tagFieldId && tagItemId) {
                    objDrillDownSearch.tagFields.push({
                        fieldId: tagFieldId,
                        fieldItemId: tagItemId
                    });
                }
            }
        });
    }

    if (!Utils.isEmptyArray(viewStructure.statusFields)) {
        viewStructure.statusFields.forEach(statusFieldData => {
            if (!Utils.isEmptyArray(Object.keys(statusFieldData))) {
                let statusFieldId = Object.keys(statusFieldData)[0];
                let statusItemId = statusFieldData[statusFieldId];

                if (statusFieldId && statusItemId) {
                    objDrillDownSearch.statusFields.push({
                        fieldId: statusFieldId,
                        fieldItemId: statusItemId
                    });
                }
            }
        });
    }

    if(!Utils.isEmptyArray(viewStructure.privateBookmark)){
        objDrillDownSearch.privateBookmark = viewStructure.privateBookmark
    }

    if(!Utils.isEmptyArray(viewStructure.sharedBookmark)){
        objDrillDownSearch.sharedBookmark = viewStructure.sharedBookmark
    }

    if(!Utils.isEmptyArray(viewStructure.mcpServerSetting)){
        objDrillDownSearch.mcpServerSetting = viewStructure.mcpServerSetting
    }

    return objDrillDownSearch;
};

/**
 * Handle search ticket knowledge
 * @param {*} argsCommon
 */
export const handleSearchTicketKnowledge = async (
    argsCommon,
    organizationId,
    visibility,
    drillDownSearch,
    paginationFrom,
    paginationSize,
    lastUserAction,
    corporationDetail,
    projectInuseDetail,
    userDetail,
    searchContentType,
    searchTagSuggest,
    removedTagItem, 
    setRemovedTagItem
) => {
    if (!organizationId || !drillDownSearch || !visibility) return;

    // visibleRange
    let visibleRange = '';
    switch (visibility) {
        case Constant.VISIBILITY_SETTING_TYPE.PRIVATE:
            visibleRange = argsCommon.userDetail.id;
            break;
        case Constant.VISIBILITY_SETTING_TYPE.PROJECT:
        case Constant.VISIBILITY_SETTING_TYPE.CUSTOMER:
            visibleRange = argsCommon.projectSelectedId;
            break;

        default:
            break;
    }

    let keywordSearch = '';
    // Replace JP space
    if (argsCommon.viewStructure?.keyword) {
        keywordSearch = argsCommon.viewStructure?.keyword.trim();
        if (keywordSearch) {
            keywordSearch = keywordSearch.toString().replace(/\s+/g, ' ');
        }
    }

    // optionSearch (keyword, method(AND/OR), target search(outline,...),....)
    let optionSearch = {
        methodSearch: argsCommon.viewStructure?.options?.method
            ? argsCommon.viewStructure?.options?.method
            : Constant.SETTING_SEARCH_KEYWORD.AND,
        attributeSearch: argsCommon.viewStructure?.options?.attribute
            ? argsCommon.viewStructure?.options?.attribute
            : Constant.SETTING_SEARCH_KEYWORD.MUTIPLE,
        keywordList: keywordSearch ? keywordSearch.split(' ') : [],
        formatSearch: ''
    };
    
    if(argsCommon?.viewStructure?.options?.isIncludePdfPage){
        optionSearch.isIncludePdfPage = 1;
    }

    if(argsCommon?.viewStructure?.options?.isSearchSynonym){
        optionSearch.isSearchSynonym = 1;
    }

    if(argsCommon?.viewStructure?.options?.getListPdfPage && !Utils.isEmptyString(argsCommon?.viewStructure?.options?.filePdfId)){
        optionSearch.getListPdfPage = 1;
        optionSearch.filePdfId = argsCommon?.viewStructure?.options?.filePdfId
    }

    if(argsCommon?.viewStructure?.options?.isIncludeAttachPdf){
        optionSearch.isIncludeAttachPdf = 1;
    }

    // Search by date / time
    let fromSearchDate;
    let toSearchDate;

    let optionSearchTimeRange = '';
    let optionSearchTimeAgo = '';
    let agoUnit = '';
    if (
        argsCommon.viewStructure.options?.searchDateType ===
        Constant.KNOWLEDGE_DATE_SEARCH_OPTION.TYPE.AGO
    ) {
        agoUnit = argsCommon.viewStructure.options?.searchDateAgoUnit
            ? argsCommon.viewStructure.options?.searchDateAgoUnit
            : Constant.KNOWLEDGE_DATE_SEARCH_OPTION.AGO_UNIT.DAY;
        let agoValue = argsCommon.viewStructure.options?.searchDateAgoValue
            ? argsCommon.viewStructure.options?.searchDateAgoValue
            : 0;
        let agoUnitTime =
            agoUnit === Constant.KNOWLEDGE_DATE_SEARCH_OPTION.AGO_UNIT.WEEK
                ? 7 * 24 * 60 * 60 * 1000
                : 24 * 60 * 60 * 1000;

        // toSearchDate is today
        toSearchDate = moment(new Date()).format('YYYY/MM/DD');

        // 0 days ago
        if (!agoValue && agoUnit === Constant.KNOWLEDGE_DATE_SEARCH_OPTION.AGO_UNIT.DAY) {
            fromSearchDate = toSearchDate;
            optionSearchTimeAgo = `投稿日：最近 0 日間`;
        } else if (!agoValue && agoUnit === Constant.KNOWLEDGE_DATE_SEARCH_OPTION.AGO_UNIT.WEEK) {
            // 0 week ago = monday - today
            fromSearchDate = moment()
                .startOf('isoweek')
                .format('YYYY/MM/DD');
            optionSearchTimeAgo = `投稿日：最近 0 週間`;
        } else {
            fromSearchDate = moment(new Date() - agoValue * agoUnitTime).format('YYYY/MM/DD');
            optionSearchTimeAgo =
                agoUnit === Constant.KNOWLEDGE_DATE_SEARCH_OPTION.AGO_UNIT.WEEK
                    ? `投稿日：最近 ${agoValue} 週間`
                    : `投稿日：最近 ${agoValue} 日間`;
        }

        optionSearch.fromSearchDate = fromSearchDate;
        optionSearch.toSearchDate = toSearchDate;
    } else {
        if (argsCommon.viewStructure.options?.from) {
            fromSearchDate = argsCommon.viewStructure.options.from;
            optionSearch.fromSearchDate = argsCommon.viewStructure.options.from;
        }

        if (argsCommon.viewStructure.options?.to) {
            toSearchDate = argsCommon.viewStructure.options.to;
            optionSearch.toSearchDate = argsCommon.viewStructure.options.to;
        }

        if (fromSearchDate && toSearchDate && fromSearchDate > toSearchDate) {
            // switch search date
            let newFromSearchDate = toSearchDate;
            let newToSearchDate = fromSearchDate;

            fromSearchDate = newFromSearchDate;
            toSearchDate = newToSearchDate;

            optionSearch.fromSearchDate = fromSearchDate;
            optionSearch.toSearchDate = toSearchDate;

            let currentViewStructure = cloneDeep(argsCommon.viewStructure);
            currentViewStructure.options.from = fromSearchDate;
            currentViewStructure.options.to = toSearchDate;
           
            argsCommon.setViewStructure(currentViewStructure);
        }

        if (fromSearchDate || toSearchDate) {
            optionSearchTimeRange = `投稿日：${fromSearchDate ? fromSearchDate : ''} ～ ${
                toSearchDate ? toSearchDate : ''
            }`;
        }
    }

    // Set state optionSearchTimeAgo / optionSearchTimeRange
    argsCommon.setOptionSearchTimeAgo(optionSearchTimeAgo);
    argsCommon.setOptionSearchTimeRange(optionSearchTimeRange);

    if (argsCommon.viewStructure.options?.otherFields) {
        optionSearch.formatSearch = JSON.stringify(argsCommon.viewStructure.options.otherFields);
    }

    // Sort
    optionSearch.sortType = argsCommon.viewStructure.options['sort']
        ? argsCommon.viewStructure.options['sort']
        : Constant.DRILLDOWN_SEARCH_OPTION_SORT_TYPE.UPDATED_AT;

    // Outfocus keyword input
    argsCommon.inputKeyWordRef.current.blur();

    // ticketProperty
    let ticketProperty = Constant.TICKET_PROPERTY.SENT;
    if (argsCommon.projectSelectedId !== Constant.KNOWLEDGE_VIEW_OPTION.ALL_KNOWLEDGE_IN_ORG) {
        let structure = JSON.parse(argsCommon?.viewSelected?.structure);
        if (!Utils.isEmpty(structure?.ticketProperty)) {
            ticketProperty = structure?.ticketProperty;
        }
    }

    let filterInput = {
        visibilitySetting: 'new_arrived_knowledge',
        visibilitySettingType: visibility,
        affiliationProject: argsCommon.projectSelectedId,
        affiliationOrganization: organizationId,
        publicRange: visibleRange,
        drillDownSearch: drillDownSearch,
        userId: argsCommon.userDetail.id,
        projectInuse: argsCommon.projectInuseDetail.id,
        userAffiliationOrganization: argsCommon.userDetail.affiliationOrganization,
        projectInuseType: argsCommon.projectInuseDetail.type,
        optionSearch,
        ticketIdList: Utils.isEmptyArray(argsCommon.ticketIdList) ? [] : argsCommon.ticketIdList,
        ticketProperty: ticketProperty,
        from: paginationFrom,
        size: paginationSize,
        optionsSort: argsCommon.optionsSort
    };
    

    let sortType = LogKibanaConstant.SORT_TYPE.CREATED_AT;
    switch (optionSearch.sortType) {
        case Constant.DRILLDOWN_SEARCH_OPTION_SORT_TYPE.UPDATED_AT:
            sortType = LogKibanaConstant.SORT_TYPE.UPDATED_AT;
            break;
        case Constant.DRILLDOWN_SEARCH_OPTION_SORT_TYPE.SIMILAR:
            sortType = LogKibanaConstant.SORT_TYPE.SIMILAR;
            break;
        case Constant.DRILLDOWN_SEARCH_OPTION_SORT_TYPE.SORT_TOTAL_PRIVATE_BOOKMARK_ASC:
            sortType = LogKibanaConstant.SORT_TYPE.PRIVATE_BOOKMARK_ASC;
            break;
        case Constant.DRILLDOWN_SEARCH_OPTION_SORT_TYPE.SORT_TOTAL_PRIVATE_BOOKMARK_DESC:
            sortType = LogKibanaConstant.SORT_TYPE.PRIVATE_BOOKMARK_DESC;
            break;
        default:
            break;
    }
    
    //create data log for write log to Kibana
    if (lastUserAction) {
        let operationScreen = LogKibanaConstant.OPERATION_SCREEN.SOLUTION_DESK;
        let { desCorp, desPrj } = getDataCorpAndProjectForLog(argsCommon.corporationSelectedId, argsCommon.projectSelectedId, argsCommon.organizationProject, corporationDetail, projectInuseDetail);
        let filterInputData = {
            ...filterInput,
            desCorp,
            desPrj
        }
        let dateUnit = '';
        if (agoUnit) {
            dateUnit = agoUnit === Constant.KNOWLEDGE_DATE_SEARCH_OPTION.AGO_UNIT.WEEK ? LogKibanaConstant.DATE_UNIT.WEEK : LogKibanaConstant.DATE_UNIT.DAY;
        }
        let inforSearch = {
            searchDateType: argsCommon.viewStructure.options?.searchDateType || Constant.KNOWLEDGE_DATE_SEARCH_OPTION.TYPE.RANGE,
            fromSearchDate: optionSearch.fromSearchDate,
            toSearchDate: optionSearch.toSearchDate,
            searchDateAgoValue: argsCommon.viewStructure.options?.searchDateAgoValue,
            searchDateAgoUnit: dateUnit,
            searchContainAny: argsCommon.searchContainAnyKnowledge,
            searchNotInclude: argsCommon.searchNotIncludeKnowledge,
            sortType: sortType,
            
            // data for view change
            viewName: Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, argsCommon.viewSelected.name),
            viewId: argsCommon.viewSelected.id,
            viewKeyword: optionSearch.keywordList,
            viewKeywordCondition: optionSearch.methodSearch,
            viewSearchTarget: optionSearch.attributeSearch === Constant.SETTING_SEARCH_KEYWORD.MUTIPLE ? LogKibanaConstant.SEARCH_TARGET.BODY : LogKibanaConstant.SEARCH_TARGET.CHAT,
            viewDateType: argsCommon.viewStructure.options?.searchDateType || Constant.KNOWLEDGE_DATE_SEARCH_OPTION.TYPE.RANGE,
            viewDateFrom: optionSearch.fromSearchDate,
            viewDateTo: optionSearch.toSearchDate,
            viewDateTerm: argsCommon.viewStructure.options?.searchDateAgoValue,
            viewDateUnit: dateUnit,
            viewOrTag: argsCommon.searchContainAnyKnowledge,// get on server
            viewExceptTag: argsCommon.searchNotIncludeKnowledge,// get on server
            viewTag: searchTagSuggest, // get on server
            viewSort: sortType,
        }
        if (inforSearch.searchDateType === Constant.KNOWLEDGE_DATE_SEARCH_OPTION.TYPE.AGO) {
            let dateTerm = argsCommon.viewStructure.options?.searchDateAgoValue || 0;
            inforSearch.searchDateAgoValue = dateTerm;
            inforSearch.viewDateTerm = dateTerm;
        }
        
        let logKibanaData;
        if(lastUserAction === LogKibanaConstant.SEARCH_ACTION.TAG_REMOVE && !Utils.isEmptyObject(removedTagItem) ) {
            let tagRemove = `${removedTagItem.tagName}@${removedTagItem.fieldName}`
            let newListTagSuggest = [];
            if (!Utils.isEmptyArray(searchTagSuggest)) {
                for (let i = 0; i < searchTagSuggest.length; i++) {
                    if (tagRemove !== searchTagSuggest[i]) {
                        newListTagSuggest.push(searchTagSuggest[i])
                    }
                }
            }
            inforSearch.viewTag = newListTagSuggest;
            argsCommon.setSearchTagSuggestKnowledge(newListTagSuggest);
            logKibanaData = createKibanaData(lastUserAction, filterInputData, optionSearch.keywordList, corporationDetail, projectInuseDetail, userDetail, searchContentType, operationScreen, newListTagSuggest, inforSearch, removedTagItem);
            //clear state click remove tag
            setRemovedTagItem({})
        }else {
            logKibanaData = createKibanaData(lastUserAction, filterInputData, optionSearch.keywordList, corporationDetail, projectInuseDetail, userDetail, searchContentType, operationScreen, searchTagSuggest, inforSearch);
        }
        
        if(!Utils.isEmptyObject(logKibanaData)) filterInput.logKibanaData = JSON.stringify(logKibanaData);
    }

    if (filterInput.affiliationProject === Constant.KNOWLEDGE_VIEW_OPTION.ALL_KNOWLEDGE_IN_ORG) {
        // override drillDownSearch ticketCreatedProjectId when search all knowledge in org (base)
        filterInput = {
            ...filterInput,
            drillDownSearch: {
                ...filterInput?.drillDownSearch,
                ticketCreatedProjectId: ""
            }
        }
    }
    // call api search ticket knowledge
    let dataList = await searchTicketKnowledge(argsCommon.API, filterInput);

    let ticketKnowledgeList = dataList?.ticketKnowledgeList;
    let totalTickets = dataList?.totalTickets;
    let inviterUsingChatAI = dataList?.inviterUsingChatAI;
   
    if (inviterUsingChatAI === 0 && [Constant.CORPORATION_CONTRACT_TYPE.GUEST, Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK].includes(corporationDetail.contractType) && (inviterUsingChatAI !== corporationDetail.inviterUsingChatAI) && isCheckMethodSimilar(argsCommon.viewStructure)) {
        let newCorpData = { ...corporationDetail, inviterUsingChatAI };
        let newViewStructure = cloneDeep(argsCommon.viewStructure);
            newViewStructure.options['sort'] =
            argsCommon.optionsSort !== Constant.DRILLDOWN_SEARCH_OPTION_SORT_TYPE.SIMILAR
                    ? argsCommon.optionsSort
                    : Constant.DRILLDOWN_SEARCH_OPTION_SORT_TYPE.UPDATED_AT;
            newViewStructure.options.method = Constant.SETTING_SEARCH_KEYWORD.AND;
           
            argsCommon.setViewStructure(newViewStructure);
            argsCommon.setCorporationDetail(newCorpData);
    }
    argsCommon.setTotalTickets(totalTickets);
    return ticketKnowledgeList
};

/**
 * openDrilldownAndDetailSearch
 * @param {*} argsCommon
 */
export const openDrilldownAndDetailSearch = argsCommon => {
    let panelType = Constant.PANEL_TYPE.KNOWLEDGE_PRJ_INUSE_DRILLDOWN_AND_DETAIL_SEARCH;
    if (argsCommon.isCustomer) {
        panelType = Constant.PANEL_TYPE.KNOWLEDGE_HELPDESK_DRILLDOWN_AND_DETAIL_SEARCH;
    }

    const clonePropsOpenDrilldown = {
        API: argsCommon.API,
        componentName: Constant.COMPONENT_NAME.DRILLDOWN_AND_DETAIL_SEARCH,
        parentPanel: argsCommon.parentPanel,
        isCustomer: argsCommon.isCustomer,
        panelId: argsCommon.panelId,
    };

    argsCommon.addNewPanel({
        type: panelType,
        tabId: panelType,
        props: clonePropsOpenDrilldown,
        panelType,
        knowledgeAffiliationOrganization: argsCommon.corporationSelectedId,
        knowledgeAffiliationProject: argsCommon.projectSelectedId,
        userDetail: argsCommon.userDetail,
        isCustomer: argsCommon.isCustomer,
    });
};

export const getInitDataOrganizationProject = async (
    API,
    userPermissionView,
    projectInuseDetail,
    currentCorporationDetail,
    setVisibilityKnowledgeAtom,
    setIsShowVisibilityKnowledgeAtom,
    setProjectSelectedId,
    setViewKnowledgeProjectSelected,
    setCorporationSelectedId,
    projectSelectedId,
    corporationSelectedId,
    isCustomer,
    isOpenFromChatAI,
    setOrganizationProject
) => {

    let selectedProjectId = projectSelectedId || userPermissionView?.projectSelectedId;

    let getProjectDetail = !Utils.isEmptyObject(projectInuseDetail) ?
        projectInuseDetail : await getProjectById(API, localStorageUtil.getSelectedProjectId());

    let getCorporationDetail = !Utils.isEmptyObject(currentCorporationDetail) ?
        currentCorporationDetail : await getCorporationById(API, localStorageUtil.getAffiliationOrganization());

    if (!Utils.isEmptyObject(getProjectDetail) && !Utils.isEmptyObject(getCorporationDetail)) {

        let initOrganizationProject = await getInitOrganizationDataInKnowledgePanel(
            userPermissionView,
            getCorporationDetail,
            getProjectDetail,
            setVisibilityKnowledgeAtom,
            setIsShowVisibilityKnowledgeAtom,
            setProjectSelectedId,
            setViewKnowledgeProjectSelected,
            setCorporationSelectedId,
            selectedProjectId,
            isCustomer
        );
        
        if (
            isOpenFromChatAI &&
            projectSelectedId === Constant.KNOWLEDGE_VIEW_OPTION.ALL_KNOWLEDGE_IN_ORG
        ) {
            initOrganizationProject = {
                ...initOrganizationProject,
                value: Constant.KNOWLEDGE_VIEW_OPTION.ALL_KNOWLEDGE_IN_ORG,
                label: I18n.get('CM-LABEL-ALL-KNOWLEDGE-IN-ORG')
            }

            setProjectSelectedId(Constant.KNOWLEDGE_VIEW_OPTION.ALL_KNOWLEDGE_IN_ORG);
            setViewKnowledgeProjectSelected(prev => ({
                ...prev,
                projectId: Constant.KNOWLEDGE_VIEW_OPTION.ALL_KNOWLEDGE_IN_ORG
            }));
        }

        setOrganizationProject(initOrganizationProject);
        return initOrganizationProject;
    }

    return {};
};

export const getUseRoleInProject = async (argsCommon, userId, projectSelectedId) => {
    if (!projectSelectedId) return;

    let userProject = await getProjectUserInUseDetail(argsCommon.API, userId, projectSelectedId);

    let role =
        userProject?.privilege === Constant.PRIVILEGE_PROJECT.PRJ_MGR
            ? Constant.PRIVILEGE_PROJECT.PRJ_MGR
            : 'MEMBER';

    argsCommon.setUserRoleInProject(role);
};

export const checkDisplayBtnAddView = (isCustomer, userRoleInProject, viewStructure, organizationProject, setIsCustomer) => {
    if (organizationProject.value === Constant.KNOWLEDGE_VIEW_OPTION.PRJ_IN_USE) {
        isCustomer = false;
    } else {
        return false;
    }
    if (isCustomer) return false;

    let visibleType = viewStructure.visibility;
    if (userRoleInProject === 'MEMBER' && visibleType !== Constant.VISIBILITY_SETTING_TYPE.PRIVATE && visibleType !== Constant.VISIBILITY_SETTING_TYPE.PROJECT) {
        return false;
    }
    return true;
};

export const onKeyPressSearchKeyWord = async (e, argsCommon) => {
    if (e.key !== 'Enter') {
        return;
    }

    onSubmitSearchListKnowledge(argsCommon);
};

/**
 * onSubmitSearchListKnowledge
 * @param {*} argsCommon
 */
export const onSubmitSearchListKnowledge = argsCommon => {
    let currentViewStructure = cloneDeep(argsCommon.viewStructure);
    if (currentViewStructure.keyword === argsCommon.keywordSearch) {
        argsCommon.setTriggerSearch(Date.now().toString());
    } else {
        currentViewStructure.keyword = argsCommon.keywordSearch;
       
        argsCommon.setViewStructure(currentViewStructure);
    }

    if (argsCommon.lastUserAction !== LogKibanaConstant.SEARCH_ACTION.KEY_WORD) {
        argsCommon.setLastUserAction(LogKibanaConstant.SEARCH_ACTION.KEY_WORD);
    }
};

/**
 * removeDrillDownSelectedSearchTimeRange
 * @param {*} argsCommon
 */
export const removeDrillDownSelectedSearchTimeRange = argsCommon => {
    // update optionSearchTimeRange
    argsCommon.setOptionSearchTimeRange('');

    // update structure
    let viewStructure = cloneDeep(argsCommon.viewStructure);
    let viewStructureOptions = cloneDeep(viewStructure.options);
    viewStructureOptions.from = null;
    viewStructureOptions.to = null;
    viewStructureOptions.searchDateType = Constant.KNOWLEDGE_DATE_SEARCH_OPTION.TYPE.RANGE;
    viewStructure.options = viewStructureOptions;
   
    argsCommon.setViewStructure(viewStructure);

    // reload list ticket
    argsCommon.setTriggerSearch(Date.now().toString());
};

/**
 * removeDrillDownSelectedSearchTimeAgo
 * @param {*} argsCommon
 */
export const removeDrillDownSelectedSearchTimeAgo = argsCommon => {
    // update optionSearchTimeAgo
    argsCommon.setOptionSearchTimeAgo('');

    // update structure
    let viewStructure = cloneDeep(argsCommon.viewStructure);
    let viewStructureOptions = cloneDeep(viewStructure.options);
    viewStructureOptions.searchDateAgoValue = 0;
    viewStructureOptions.searchDateAgoUnit = Constant.KNOWLEDGE_DATE_SEARCH_OPTION.AGO_UNIT.DAY;
    viewStructureOptions.searchDateType = Constant.KNOWLEDGE_DATE_SEARCH_OPTION.TYPE.RANGE;
    viewStructure.options = viewStructureOptions;
   
    argsCommon.setViewStructure(viewStructure);

    // reload list ticket
    argsCommon.setTriggerSearch(Date.now().toString());
};

/**
 * getDrilldownWithPagination
 * @param {*} argsCommon
 * @param {*} filterParams
 * @param {*} drillDown
 * @returns
 */
export const getDrilldownWithPagination = async (argsCommon, filterParams, drillDown = {}, isDefault= false, setCurrentSearchParams = () => {}) => {
    // const startTime = performance.now();
    const queryData = await getDrilldownData(argsCommon.API, filterParams, setCurrentSearchParams);
    // const endTime = performance.now();
    // const queryDurationMs = endTime - startTime;

    let listData = Utils.convertJSONDataToObject(queryData?.data);
    let listDrillDown = listData;

    // console.log(`✅ Timer query Drilldown: ${queryDurationMs.toFixed(2)} ms `);

   
    if (listDrillDown?.s3Path) {
        const response = await fetch(listDrillDown?.s3Path); 
        const jsonData = await response.json();
        listDrillDown = Utils.convertJSONDataToObject(jsonData?.data);
    }

    let options = filterParams?.viewStructure?.options;
    if (!isDefault && (!options?.getListPdfPage && Utils.isEmptyString(options?.filePdfId))) {
        let drillDownTag = listDrillDown.tag;

        if (!Utils.isEmptyObject(drillDownTag)) {
            let drillDownTagClone = {};
            let pdfSystemTagField = ['item', 'chapter', 'section', "subSection"];
            for (const key in drillDownTag) {
                let tagData = drillDownTag[key];
                if (!pdfSystemTagField.includes(tagData?.data?.sysField)) {
                    drillDownTagClone[key] = tagData;
                }
                listDrillDown.tag = drillDownTagClone;

            }
        }
    }

    if (!Utils.isEmptyObject(drillDown)) {
        listDrillDown = mappingDrillDown(drillDown, listData);
    }
    return listDrillDown;
};

const sortDataPermission = (listPermission, corporationDetail = {}) => {
    if (corporationDetail && Utils.isGuestContractType(corporationDetail) && Utils.isEmptyArray(listPermission.guestCustomerProject)) {
        listPermission.guestCustomerProject = [ {id: 'dummy_guest_customer_prj_id', name: Constant.PROJECT_GUEST_CUSTOMER_NAME }];
    }

    let result = {}
    result.listPrjInOrg = Utils.sortListByLabelDictionaryASC(listPermission.orgProject, 'name');
    result.listB2BCustomerPrj = Utils.sortListByLabelDictionaryASC(listPermission.b2bCustomerProject, 'name');
    result.listB2BHelpdeskPrj = Utils.sortListByLabelDictionaryASC(listPermission.b2bHelpdeskProject, 'name');
    result.listOrthers = Utils.sortListByLabelDictionaryASC([...listPermission.baseProject, ...listPermission.guestCustomerProject], 'name');
    result.baseProject = listPermission.baseProject;
    result.guestCustomerProject = listPermission.guestCustomerProject;
    return result;
}

/**
 * mappingDrillDown
 * @param {*} currentDrillDown 
 * @param {*} newDrillDown 
 * @returns 
 */
export const mappingDrillDown = (currentDrillDown, newDrillDown) => {
    if (!Utils.isEmptyObject(currentDrillDown) && !Utils.isEmptyObject(newDrillDown)) {
        for (const key of Object.keys(currentDrillDown)) {
            if (newDrillDown[key]['total']) {
                currentDrillDown[key]['total'] += newDrillDown[key]['total'];
            }
            switch (key) {
                case 'form':
                case 'creator':
                case 'updator':
                case 'proxiedUser': {
                    const currentChildData = currentDrillDown[key];
                    const newChildData = newDrillDown[key];
                    for (const childKey of Object.keys(newChildData)) {
                        if (!currentChildData[childKey]) {
                            currentChildData[childKey] = newChildData[childKey];
                            continue;
                        }
                        if (currentChildData[childKey]) {
                            if (
                                currentChildData[childKey]['count'] &&
                                newChildData[childKey]['count']
                            ) {
                                currentChildData[childKey]['count'] +=
                                    newChildData[childKey]['count'];
                            }
                        }
                    }
                    break;
                }
                case 'suffixOfAttachments': {
                    if (newDrillDown[key]['data']) {
                        if (!currentDrillDown[key]['data']) {
                            currentDrillDown[key]['data'] = newDrillDown[key]['data'];
                        } else {
                            for (const childKey of Object.keys(newDrillDown[key]['data'])) {
                                if (currentDrillDown[key]['data'][childKey]) {
                                    currentDrillDown[key]['data'][childKey] +=
                                        newDrillDown[key]['data'][childKey];
                                } else {
                                    currentDrillDown[key]['data'][childKey] =
                                        newDrillDown[key]['data'][childKey];
                                }
                            }
                        }
                    }
                    break;
                }
                case 'tag': {
                    // const currentChildData = currentDrillDown[key];
                    // const newChildData = newDrillDown[key];
                    // for (const childKey of Object.keys(newChildData)) {
                    //     if (!currentChildData[childKey]) {
                    //         currentChildData[childKey] = newChildData[childKey];
                    //         continue;
                    //     }
                    //     if (currentChildData[childKey]) {
                    //         if (
                    //             currentChildData[childKey]['total'] &&
                    //             newChildData[childKey]['total']
                    //         ) {
                    //             currentChildData[childKey]['total'] +=
                    //                 newChildData[childKey]['total'];
                    //         }

                    //         if (!Utils.isEmptyArray(newChildData[childKey]?.itemList)) {
                    //             let currentItemList = currentChildData[childKey]?.itemList || [];
                    //             currentChildData[childKey].itemList = [...currentItemList, ...newChildData[childKey]?.itemList]
                    //         }
                    //     }
                    // }
                    break;
                }
                case 'status':
                    break;
                default:
                    break;
            }
        }
    }

    return currentDrillDown;
};

/**
 * getCurrentDrilldownData
 * @param {*} argsCommon
 * @param {*} filterParams
 * @returns
 */
export const getCurrentDrilldownData = async (argsCommon, filterParams, isDefault = false, setCurrentSearchParams = () => {}) => {
    let queryData = await getDrilldownWithPagination(argsCommon, filterParams,{}, isDefault, setCurrentSearchParams);
    let listData = Utils.convertJSONDataToObject(queryData);

    let drilldownData = [];
    let arrCustomField = [];
    let arrCustomFieldTag = [];
    let arrCustomFieldStatus = [];
    let suggestionList = [];
    let postTargetProjectField = {};
    let rawDrilldownData = cloneDeep(listData)

    if (!Utils.isEmptyObject(listData)) {
        for (const [key, value] of Object.entries(listData)) {
            const hideInProject = Boolean(value?.hideInProject);
            // only display on suggestionList
            if (!isDefault && hideInProject) {
                continue;
            }
            delete value.hideInProject;
            if (!Utils.isEmptyObject(value)) {
                if (
                    [
                        Constant.FORMAT_OPTION_SEARCH.FORM,
                        Constant.FORMAT_OPTION_SEARCH.CREATOR,
                        Constant.FORMAT_OPTION_SEARCH.UPDATOR,
                        Constant.FORMAT_OPTION_SEARCH.PROXIED_USER,
                        Constant.FORMAT_OPTION_SEARCH.PUBLIC_RANGE,
                        Constant.FORMAT_OPTION_SEARCH.SUFFIX_OF_ATTACHMENTS,
                        Constant.FORMAT_OPTION_SEARCH.PRIVATE_BOOKMARK,
                        Constant.FORMAT_OPTION_SEARCH.SHARED_BOOKMARK,
                        Constant.FORMAT_OPTION_SEARCH.MCP_SERVER_SETTING,
                    ].includes(key) &&
                    value.total
                ) {
                    let processData;
                    let child = [];

                    switch (key) {
                        case Constant.FORMAT_OPTION_SEARCH.FORM:
                            processData = processDrillDownDataForm(
                                argsCommon.viewStructure,
                                key,
                                value
                            );
                            break;
                        case Constant.FORMAT_OPTION_SEARCH.CREATOR:
                        case Constant.FORMAT_OPTION_SEARCH.UPDATOR:
                        case Constant.FORMAT_OPTION_SEARCH.PROXIED_USER:
                            processData = processDrillDownDataUser(
                                argsCommon.viewStructure,
                                key,
                                value
                            );
                            break;
                        case Constant.FORMAT_OPTION_SEARCH.PUBLIC_RANGE:
                            processData = processDrillDownDataPublicRange(
                                argsCommon.viewStructure,
                                key,
                                value
                            );
                            break;
                        case Constant.FORMAT_OPTION_SEARCH.SUFFIX_OF_ATTACHMENTS:
                            processData = processDrillDownDataSuffixOfAttachments(
                                argsCommon.viewStructure,
                                key,
                                value
                            );
                            break;
                        case Constant.FORMAT_OPTION_SEARCH.PRIVATE_BOOKMARK:
                            processData = processDrillDownDataPrivateBookmark(
                                argsCommon.viewStructure,
                                key,
                                value
                            );
                            break;
                        case Constant.FORMAT_OPTION_SEARCH.SHARED_BOOKMARK:
                                processData = processDrillDownDataSharedBookmark(
                                argsCommon.viewStructure,
                                key,
                                value
                            );
                            break;
                        case Constant.FORMAT_OPTION_SEARCH.MCP_SERVER_SETTING:
                            processData = processDrillDownDataMCPServerSetting(
                                argsCommon.viewStructure,
                                key,
                                value
                            );
                            break
                        default:
                            break;
                    }

                    child = processData.child || [];
                    suggestionList = suggestionList.concat(processData.optionsList);
                    drilldownData.push({
                        id: key,
                        label: getSystemFieldNameInDrillDown(key),
                        total: value.total,
                        usage: Constant.DRILLDOWN_USAGE.SYSTEM,
                        child,
                        isShowMore: false,
                        orderInList: value.orderInList
                    });
                } else if (
                    [
                        Constant.FORMAT_OPTION_SEARCH.STATUS_FIELD,
                        Constant.FORMAT_OPTION_SEARCH.TAG_FIELD
                    ].includes(key)
                ) {
                    for (const fieldData of Object.values(value)) {
                        if (fieldData?.data?.sysField === Constant.DRILLDOWN_SYSTEM_FIELD.POST_TARGET_PROJECT) {
                            postTargetProjectField = fieldData;
                            continue;
                        }
                        const hideFieldInProject = Boolean(fieldData?.data?.hideInProject ?? fieldData?.hideInProject);
                        if (!isDefault && hideFieldInProject) continue; // only display on suggestionList
                        delete fieldData.hideInProject;

                        if (key === Constant.FORMAT_OPTION_SEARCH.TAG_FIELD) {
                            let customFieldData = { ...fieldData, type: key };
                            switch (customFieldData?.data?.sysField) {
                                case Constant.SYSTEM_FIELD.CHAPTER:
                                    customFieldData.data.internalSort = 1;
                                    break;
                                case Constant.SYSTEM_FIELD.SECTION:
                                    customFieldData.data.internalSort = 2;
                                    break;
                                case Constant.SYSTEM_FIELD.SUBSECTION:
                                    customFieldData.data.internalSort = 3;
                                    break;
                                case Constant.SYSTEM_FIELD.ITEM:
                                    customFieldData.data.internalSort = 4;
                                    break;
                                default:
                                    break;
                            }
                            arrCustomFieldTag.push(customFieldData);
                            continue;
                        }

                        if (fieldData.total && !Utils.isEmptyArray(fieldData.itemList)) {
                            let customFieldData = { ...fieldData, type: key };
                            if (key === Constant.FORMAT_OPTION_SEARCH.STATUS_FIELD) {
                                arrCustomFieldStatus.push(customFieldData);
                            }
                        }
                    }
                }
            }
        }
    }

    // Sort custom field same type
    if (argsCommon?.viewStructure?.options?.filePdfId && argsCommon?.viewStructure?.options?.getListPdfPage) {
        arrCustomFieldTag = arrCustomFieldTag.sort((a, b) => {
            return parseInt(a?.data?.internalSort) - parseInt(b?.data?.internalSort);
        });
    } else {
        arrCustomFieldTag = arrCustomFieldTag.sort((a, b) => {
            return new Date(b.data.createdAt) - new Date(a.data.createdAt);
        });
        if (filterParams.projectId !== Constant.KNOWLEDGE_VIEW_OPTION.ALL_KNOWLEDGE_IN_ORG) {
            // Arrange tag field order according to the order in the tag fields list
            arrCustomFieldTag = sortListTagFieldByOrder(arrCustomFieldTag);
        }
    }
    // Arrange the order of card systems before custom cards
    arrCustomFieldTag = sortListTagFieldBySysField(arrCustomFieldTag);

    arrCustomFieldStatus = arrCustomFieldStatus.sort((a, b) => {
        return new Date(b.data.createdAt) - new Date(a.data.createdAt);
    });

    arrCustomField = arrCustomFieldTag.concat(arrCustomFieldStatus);

    if (!Utils.isEmptyArray(arrCustomField)) {
        for (let field of arrCustomField) {
            if (field.type === Constant.FORMAT_OPTION_SEARCH.TAG_FIELD && field.itemList.length === 0) {
                drilldownData.push({
                    id: field?.data?.id,
                    label: Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, field?.data?.name),
                    total: field.total,
                    usage: Constant.DRILLDOWN_USAGE.TAG,
                    child: [],
                    itemListS3Path: field.itemListS3Path,
                    itemListTotal: field.itemListTotal,
                    sysField: field?.sysField,
                    orderInList: field.orderInList,
                    isMultiple: field.isMultiple,
                    optionType: field.optionType,
                });
                continue;
            }

            let child = [];
            field.itemList.forEach(item => {
                if (item.data?.id) {
                    let indexInChildList = Utils.findIndexInArrayById(item.data?.id, child);
                    if (indexInChildList === -1) {
                        let childName = Utils.getTextByLanguage(
                            Constant.LANGUAGE_TYPE.JP,
                            item.data.name
                        );

                        if (item?.type === Constant.DRILLDOWN_TAG_ITEM_TYPE.MASTER_TAG_FIELD) {
                            childName = item.data.name;
                        }
                        child.push({
                            id: item.data.id,
                            label: childName,
                            total: item.count,
                            type: item?.type,
                            no: item.data?.no,
                            hitNumber: item.data?.hitNumber
                        });
                    } else {
                        child[indexInChildList].total += 1;
                    }
                }
            });

            // Sort child
            child = knowledgeSortFieldChild(field, child);

            drilldownData.push({
                id: field.data.id,
                label: Utils.isEmptyObject(field.data.name)
                    ? field.data.name
                    : Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, field.data.name),
                total: field.total,
                usage:
                    field.type === Constant.FORMAT_OPTION_SEARCH.STATUS_FIELD
                        ? Constant.DRILLDOWN_USAGE.STATUS
                        : Constant.DRILLDOWN_USAGE.TAG,
                child,
                sysField: field?.data?.sysField,
                orderInList: field.orderInList,
                itemListS3Path: field.itemListS3Path,
                isMultiple: field.isMultiple,
                optionType: field.optionType,
            });

            if (!Utils.isEmptyArray(child)) {
                let itemData = {
                    id: field.data.id,
                    usage:
                        field.type === Constant.FORMAT_OPTION_SEARCH.STATUS_FIELD
                            ? Constant.DRILLDOWN_USAGE.STATUS
                            : Constant.DRILLDOWN_USAGE.TAG
                };
                child.forEach(childField => {
                    if (!isSelectedOption(argsCommon.viewStructure, itemData, childField.id)) {
                        let ticketCount = '';
                        if (childField.total) {
                            ticketCount = `(${childField.total})`;
                        }
                        suggestionList.push({
                            groupId: `${itemData.id}:${childField.id}`,
                            type: itemData.id,
                            id: `${childField.id}`,
                            label: `${childField.label}${ticketCount} ← ${Utils.getTextByLanguage(
                                Constant.LANGUAGE_TYPE.JP,
                                field.data.name
                            )}`,
                            usage: itemData.usage,
                            labelForSearch: `${childField.label}${Utils.getTextByLanguage(
                                Constant.LANGUAGE_TYPE.JP,
                                field.data.name
                            )}`,
                            nameOfChild: childField.label
                        });
                    }
                });
            }
        };
    }

    const destinationPrjId = argsCommon?.destinationPrjId
    const corporationSelectedId = argsCommon?.corporationSelectedId
    const corporationDetail = argsCommon?.corporationDetail
    const ticketProperty = filterParams?.ticketProperty
    const projectInuseDetail = argsCommon?.projectInuseDetail

    if (
        Utils.isEmptyString(destinationPrjId) && // is not selected ticketCreatedProjectId
        corporationSelectedId === corporationDetail?.id && // is not select externalPrj
        ![
            Constant.TICKET_PROPERTY.DRAFT,
            Constant.TICKET_PROPERTY.DELETE,
            Constant.TICKET_PROPERTY.SYNONYM
        ].includes(ticketProperty) &&
        !Utils.isProjectGuest(projectInuseDetail)
    ) {
        const destinationPrjTag = {
            id: Constant.FORMAT_OPTION_SEARCH.TICKET_CREATED_PROJECT_ID,
            isShowMore: false,
            label: "投稿先プロジェクト",
            usage: "SYSTEM",
            child: []
        };

        let affiliationProjects = listData?.affiliationProjects;
        if (!Utils.isEmptyObject(affiliationProjects) && !Utils.isEmptyObject(projectInuseDetail)) {
            delete affiliationProjects?.total;
            const affiliationProjectsValues = Object.values(affiliationProjects)
            const affiliationProjectsMapping = _.map(affiliationProjectsValues, i => i?.data).filter(i=> !Utils.isEmptyObject(i));
            if (projectInuseDetail?.type !== Constant.PROJECT_TYPE.BASE && projectInuseDetail?.type !== Constant.PROJECT_TYPE.CUSTOMER) {
                affiliationProjectsMapping.push(projectInuseDetail)
            }

            let otherPrj = affiliationProjectsMapping
                .filter(prj => prj.id !== projectInuseDetail?.id)
                .map(prj => ({
                    id: prj.id,
                    label: Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, prj.name)
                }));
            otherPrj = Utils.sortByDrillDownLabelAsc(otherPrj);

            destinationPrjTag.child = [...otherPrj];

            let prjInuse = affiliationProjectsMapping.find(prj => prj.id === projectInuseDetail?.id);
            if (prjInuse) {
                destinationPrjTag.child = [
                    {
                        id: prjInuse?.id,
                        label: I18n.get('CM-LABEL-PRJ-IN-USE')
                    },
                    ...otherPrj
                ];
            }
        }

        // handle orderInList to sort
        destinationPrjTag.orderInList = !Utils.isEmptyObject(postTargetProjectField)
            ? postTargetProjectField.orderInList
            : drilldownData.filter(item => item.usage === Constant.DRILLDOWN_USAGE.SYSTEM).length + 1
        
        drilldownData.push(destinationPrjTag);

        // add new suggestion
        const ticketCreatedProjectIdSuggestionList = destinationPrjTag.child.map(child => ({
                groupId: Constant.FORMAT_OPTION_SEARCH.TICKET_CREATED_PROJECT_ID,
                id: child.id,
                label: `${child.label} ← ${I18n.get('CM-DROPDOWN-PRJ-CREATE-KNOWLEDGE')}`,
                labelForSearch: child.label,
                nameOfChild: child.label,
                type: child.id,
                usage: "SYSTEM",
            }))

        suggestionList.push(...ticketCreatedProjectIdSuggestionList)
    };

    drilldownData = drilldownData.sort((a, b) => {
        // Get orderInList values
        let orderA = a.orderInList;
        let orderB = b.orderInList;
        
        // Special handling for mcpServerSetting: if no orderInList, push to bottom
        if (a.id === Constant.FORMAT_OPTION_SEARCH.MCP_SERVER_SETTING && (orderA === undefined || orderA === null)) {
            orderA = Number.MAX_SAFE_INTEGER;
        }
        if (b.id === Constant.FORMAT_OPTION_SEARCH.MCP_SERVER_SETTING && (orderB === undefined || orderB === null)) {
            orderB = Number.MAX_SAFE_INTEGER;
        }
        
        return orderA - orderB;
    });

    return { drillDownData: drilldownData, sugguestionList: suggestionList, rawDrilldownData: rawDrilldownData };
};

const knowledgeSortFieldChild = (field, currentChild) => {
    if (!currentChild || Utils.isEmptyArray(currentChild)) return [];

    let sortChild = [...currentChild];

    switch(field?.data?.displayOrder) {
        case Constant.DISPLAY_ORDER_TAG_FIELD.HITS_NUMBER_ORDER:
            sortChild = Utils.sortByHitNumberDesc(sortChild);
            break;
        case Constant.DISPLAY_ORDER_TAG_FIELD.DICTIONARY_ORDER:
            sortChild = Utils.sortByDrillDownLabelAsc(sortChild);
            break;
        case Constant.DISPLAY_ORDER_TAG_FIELD.CUSTOMISE:
        default:
            sortChild = Utils.sortDrillDownByNo(sortChild);
            break;
    }

    // Fix sort for field AI-コンテンツフォーマット: https://new.redmine.ominext.com/issues/180633
    if (field?.data?.sysField === Constant.AI_AUTO.SYSTEM_FIELD.FORM_ACTIVE) {
        sortChild = sortFormInDrilldown(sortChild);
    }

    return sortChild;
}

export const sortListTagFieldByOrder = (listTagFields) => {
    let newListTagField = listTagFields.sort((a, b) => {
        return Number(a.data.order) - Number(b.data.order);
    });
    return  newListTagField;
}


// Re order logic
export const sortListTagFieldBySysField = (listSysTagFields) => {
    if (Utils.isEmptyArray(listSysTagFields)) return [];
    listSysTagFields.sort((a, b) => {
        const aSysField = a?.data?.sysField;
        const bSysField = b?.data?.sysField;

        const aPriority = TagSysFieldPriority.indexOf(aSysField);
        const bPriority = TagSysFieldPriority.indexOf(bSysField);

        if (aSysField && !bSysField) return -1;
        if (bSysField && !aSysField) return 1;

        if (!aSysField && !bSysField) return 0;

        if (aPriority !== -1 && bPriority !== -1) {
            return aPriority - bPriority;
        }

        if (aPriority !== -1) return -1;
        if (bPriority !== -1) return 1;

        return 0;
    });

    return listSysTagFields;
};

/**
 * processDrillDownDataForm
 * @param {*} viewStructure
 * @param {*} key
 * @param {*} value
 * @returns
 */
export const processDrillDownDataForm = (viewStructure, key, value) => {
    let child = [];
    let optionsList = [];

    for (const [keyChild, valueChild] of Object.entries(value)) {
        if (keyChild && keyChild !== 'total' && keyChild !== Constant.ORDER_IN_LIST_FIELD_KEY) {
            let childLabel = getChildNameInDrillDown(key, valueChild.data);

            child.push({
                id: keyChild,
                label: childLabel,
                total: valueChild.count,
                createdAt: valueChild.data.createdAt
            });

            let itemData = {
                id: key,
                usage: Constant.DRILLDOWN_USAGE.SYSTEM
            };
            if (!isSelectedOption(viewStructure, itemData, keyChild)) {
                let ticketCount = '';
                if (valueChild.count) {
                    ticketCount = `(${valueChild.count})`;
                }
                optionsList.push({
                    groupId: `${key}:${keyChild}`,
                    type: key,
                    id: `${keyChild}`,
                    label: `${childLabel}${ticketCount} ← ${getSystemFieldNameInDrillDown(key)}`,
                    usage: Constant.DRILLDOWN_USAGE.SYSTEM,
                    labelForSearch: `${childLabel}${getSystemFieldNameInDrillDown(key)}`,
                    nameOfChild: childLabel
                });
            }
        }
    }

    child = sortFormInDrilldown(child);

    return { child, optionsList };
};

/**
 * processDrillDownDataPublicRange
 * @param {*} viewStructure
 * @param {*} key
 * @param {*} value
 * @returns
 */
const processDrillDownDataPublicRange = (viewStructure, key, value) => {
    let suffixData = value.data;
    let child = [];
    let optionsList = [];

    for (const [keyChild, valueChild] of Object.entries(suffixData)) {
        if (valueChild) {
            child.push({
                id: keyChild,
                label: getPublicRangeName(keyChild),
                total: valueChild
            });

            let itemData = {
                id: key,
                usage: Constant.DRILLDOWN_USAGE.SYSTEM
            };
            if (!isSelectedOption(viewStructure, itemData, keyChild)) {
                let ticketCount = '';
                if (valueChild) {
                    ticketCount = `(${valueChild})`;
                }
                optionsList.push({
                    groupId: `${key}:${keyChild}`,
                    type: key,
                    id: `${keyChild}`,
                    label: `${getPublicRangeName(
                        keyChild
                    )}${ticketCount} ← ${getSystemFieldNameInDrillDown(key)}`,
                    usage: Constant.DRILLDOWN_USAGE.SYSTEM,
                    labelForSearch: `${getPublicRangeName(keyChild)}${getSystemFieldNameInDrillDown(
                        key
                    )}`,
                    nameOfChild: keyChild
                });
            }
        }
    }

    return { child, optionsList };
};


/**
 * processDrillDownDataPrivateBookmark
 * @param {*} viewStructure 
 * @param {*} key 
 * @param {*} value 
 * @returns 
 */
const processDrillDownDataPrivateBookmark = (viewStructure, key, value) => {
    let child = [];
    let optionsList = [];

    for (const [keyChild, valueChild] of Object.entries(value)) {
        if (keyChild && keyChild !== 'total' && keyChild !== Constant.ORDER_IN_LIST_FIELD_KEY) {
            let dataOfBookMark = valueChild.data;
            let childLabel = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP,dataOfBookMark.name);

            child.push({
                id: keyChild,
                label: childLabel,
                total: valueChild.count,
            });
            let itemData = {
                id: key,
                usage: Constant.DRILLDOWN_USAGE.SYSTEM
            };
            if (!isSelectedOption(viewStructure, itemData, keyChild)) {
                let ticketCount = '';
                if (valueChild.count) {
                    ticketCount = `(${valueChild.count})`;
                }
                optionsList.push({
                    groupId: `${key}:${keyChild}`,
                    type: key,
                    id: `${keyChild}`,
                    label: `${childLabel}${ticketCount} ← ${getSystemFieldNameInDrillDown(key)}`,
                    usage: Constant.DRILLDOWN_USAGE.SYSTEM,
                    labelForSearch: `${childLabel}${getSystemFieldNameInDrillDown(key)}`,
                    nameOfChild: childLabel
                });
            }
        }
    }

    
    if(!Utils.isEmptyArray(child)){
        child = Utils.sortByDrillDownLabelAsc(child)
    };

    if(!Utils.isEmptyArray(optionsList)){
        optionsList = Utils.sortByDrillDownLabelAsc(optionsList)
    };

    return { child, optionsList };
};

/**
 * processDrillDownDataPrivateBookmark
 * @param {*} viewStructure 
 * @param {*} key 
 * @param {*} value 
 * @returns 
 */
const processDrillDownDataSharedBookmark = (viewStructure, key, value) => {
    let child = [];
    let optionsList = [];

    for (const [keyChild, valueChild] of Object.entries(value)) {
        if (keyChild && keyChild !== 'total' && keyChild !== Constant.ORDER_IN_LIST_FIELD_KEY) {
            
            let dataOfBookMark = valueChild.data;
            let childLabel = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP,dataOfBookMark.name);

            child.push({
                id: keyChild,
                label: childLabel,
                total: valueChild.count,
            });

            let itemData = {
                id: key,
                usage: Constant.DRILLDOWN_USAGE.SYSTEM
            };

            if (!isSelectedOption(viewStructure, itemData, keyChild)) {
                let ticketCount = '';
                if (valueChild.count) {
                    ticketCount = `(${valueChild.count})`;
                }
                optionsList.push({
                    groupId: `${key}:${keyChild}`,
                    type: key,
                    id: `${keyChild}`,
                    label: `${childLabel}${ticketCount} ← ${getSystemFieldNameInDrillDown(key)}`,
                    usage: Constant.DRILLDOWN_USAGE.SYSTEM,
                    labelForSearch: `${childLabel}${getSystemFieldNameInDrillDown(key)}`,
                    nameOfChild: childLabel
                });
            }
        }
    }

    if(!Utils.isEmptyArray(child)){
        child = Utils.sortByDrillDownLabelAsc(child)
    };

    if(!Utils.isEmptyArray(optionsList)){
        optionsList = Utils.sortByDrillDownLabelAsc(optionsList)
    };

    return { child, optionsList };
};

const processDrillDownDataMCPServerSetting = (viewStructure, key, value) => {
    let child = [];
    let optionsList = [];

    for (const [keyChild, valueChild] of Object.entries(value)) {
        if (keyChild && keyChild !== 'total' && keyChild !== Constant.ORDER_IN_LIST_FIELD_KEY) {
            
            let dataOfMCPServer = valueChild.data;
            let childLabel = dataOfMCPServer.name;

            child.push({
                id: keyChild,
                label: childLabel,
                total: valueChild.count,
            });

            let itemData = {
                id: key,
                usage: Constant.DRILLDOWN_USAGE.SYSTEM
            };

            if (!isSelectedOption(viewStructure, itemData, keyChild)) {
                let ticketCount = '';
                if (valueChild.count) {
                    ticketCount = `(${valueChild.count})`;
                }
                optionsList.push({
                    groupId: `${key}:${keyChild}`,
                    type: key,
                    id: `${keyChild}`,
                    label: `${childLabel}${ticketCount} ← ${getSystemFieldNameInDrillDown(key)}`,
                    usage: Constant.DRILLDOWN_USAGE.SYSTEM,
                    labelForSearch: `${childLabel}${getSystemFieldNameInDrillDown(key)}`,
                    nameOfChild: childLabel
                });
            }
        }
    }

    if(!Utils.isEmptyArray(child)){
        child = Utils.sortByDrillDownLabelAsc(child)
    };

    if(!Utils.isEmptyArray(optionsList)){
        optionsList = Utils.sortByDrillDownLabelAsc(optionsList)
    };

    return { child, optionsList };
};



function getStringAfterArrow(inputString) {
    // Sử dụng phương thức split() để tách chuỗi thành mảng
    var parts = inputString.split('←');
  
    // Lấy phần tử cuối cùng của mảng
    var result = parts[parts.length - 1].trim();
  
    return result;
  }
/**
 * onSelectSugguestOption
 * @param {*} e
 * @param {*} value
 * @param {*} argsCommon
 * @returns
 */
export const onSelectSugguestOption = (e, value, argsCommon) => {
    if (Utils.isEmptyObject(value)) {
        return;
    }

    let viewStructure = cloneDeep(argsCommon.viewStructure);

    let itemData = {
        id: value.type,
        usage: value.usage
    };
    let isSelected = isSelectedOption(viewStructure, itemData, value.id);
    if (isSelected) {
        return;
    }

    viewStructure.keyword = '';

    let objField = {};
    objField[value.type] = value.id;

    if (value.usage === Constant.DRILLDOWN_USAGE.STATUS) {
        let listChild = value.child;
        if (!Utils.isEmptyArray(listChild?.listStatusId)) {
            let arrFilterFieldStatus = [];
            listChild?.listStatusId.forEach(statusItem => {
                let objFilterStatusItem = {};
                objFilterStatusItem[statusItem.fieldId] = statusItem.statusId;
                arrFilterFieldStatus.push(objFilterStatusItem);
            });
            viewStructure.statusFields = arrFilterFieldStatus;
        }
    } else if (value.usage === Constant.DRILLDOWN_USAGE.TAG) {
        if (viewStructure.hasOwnProperty('tagFields')) {
            viewStructure.tagFields.push(objField);
        } else {
            viewStructure.tagFields = [objField];
        }
    
    }else if (value.type === Constant.FORMAT_OPTION_SEARCH.MCP_SERVER_SETTING) {
        if (viewStructure.hasOwnProperty(Constant.FORMAT_OPTION_SEARCH.MCP_SERVER_SETTING)) {
            viewStructure[itemData.id].push(value.id);
        } else {
            viewStructure[itemData.id] = [value.id];
        }
    } else if (itemData.id === 'privateBookmark' || itemData.id === 'sharedBookmark') {
        objField = {
            bookmarkId: value.id,
            userSelectId: argsCommon?.userDetail?.id,
            projectSelectId: argsCommon?.projectInuseDetail?.id
        }
        if (viewStructure.hasOwnProperty(itemData.id)) {
            viewStructure[itemData.id].push(objField);
        } else {
            viewStructure[itemData.id] = [objField];
        }
    } else {
        if (viewStructure.hasOwnProperty('fields')) {
            viewStructure.fields.push(objField);
        } else {
            viewStructure.fields = [objField];
        }
    }

    if (argsCommon.setViewStructure) {
       
        argsCommon.setViewStructure(viewStructure);
    }
    argsCommon.setKeywordSearch('');

    if (argsCommon.lastUserAction !== LogKibanaConstant.SEARCH_ACTION.TAG_SUGGEST) {
        argsCommon.setLastUserAction(LogKibanaConstant.SEARCH_ACTION.TAG_SUGGEST);
    }
    let listTagSuggest = [];
    if (argsCommon.isPublicKnowledge) {
        listTagSuggest = [...argsCommon.searchPublicTagSuggest];
    } else if (argsCommon.isKnowledge) {
        listTagSuggest = [...argsCommon.searchTagSuggestKnowledge];
    } else {
        listTagSuggest = [...argsCommon.searchTagSuggest]
    }
    let fieldName = getSystemFieldNameInDrillDown(value.type);
    if (!fieldName && value.usage === Constant.FORM_USAGE.STATUS) {
        fieldName = I18n.get('FIELDFORMLB022');
    }
    if (!fieldName && value.usage === Constant.FORM_USAGE.TAG) {
        fieldName = getStringAfterArrow(value.label);
    }
    let nameOfSelectItem = Utils.isEmptyString(value.nameOfChild) ? value.labelForSearch : value.nameOfChild
    let tagSuggest = nameOfSelectItem + '@' + fieldName;
    listTagSuggest.push(tagSuggest);
    if (argsCommon.isPublicKnowledge) {
        argsCommon.setSearchPublicTagSuggest(listTagSuggest);
    } else if (argsCommon.isKnowledge) {
        argsCommon.setSearchTagSuggestKnowledge(listTagSuggest);
    } else {
        argsCommon.setSearchTagSuggest(listTagSuggest);
    }

    if (Utils.isTypeFunction(argsCommon?.setDestinationPrjId) && value.groupId === Constant.FORMAT_OPTION_SEARCH.TICKET_CREATED_PROJECT_ID) {
        argsCommon?.setDestinationPrjId(value.id);

        if (Utils.isTypeFunction(argsCommon.setSugguestionList)) {
            argsCommon.setSugguestionList(prev => {
                let oldSugguestionList = [...prev];
                return oldSugguestionList.filter(data => data.groupId !== Constant.FORMAT_OPTION_SEARCH.TICKET_CREATED_PROJECT_ID)
            })
        }
    }

    return viewStructure;
};

export const normalizeString = str => {
    if (!str) return '';
    return str
        .normalize('NFKC')
        .toLowerCase()
        .replace(/[Ａ-Ｚａ-ｚ０-９]/g, char => String.fromCharCode(char.charCodeAt(0) - 0xfee0));
};

/**
 * filterSugguestionOption
 */
export const filterSugguestionOption = createFilterOptions({
    matchFrom: 'any',
    ignoreCase: true,
    stringify: option => normalizeString(option?.labelForSearch || '')
});
  

export const handleClickCreateTicketType = (ticketType, argsCommon, props, isCustomer) => {
    argsCommon.setCreateTicketTypePopover(null);
    let propsClone = {
        isCustomer: isCustomer,
        visibilitySettingType: argsCommon.visibilityKnowledgeAtom,
        projectSelectedId: argsCommon.projectSelectedId,
        corporationSelectedId: argsCommon.corporationSelectedId,
        panelId: props.panelId
    }

    switch (ticketType) {
        case Constant.TICKET_TYPE.MASTER_KNOWLEDGE:
            argsCommon.addNewPanel({
                type: Constant.PANEL_TYPE.KNOWLEDGE_TICKET_DETAIL,
                tabId: `${Constant.PANEL_TYPE.KNOWLEDGE_CREATE_TICKET}_${Date.now().toString()}`,
                props: {
                    ...propsClone,
                    createTicketType: Constant.TICKET_TYPE.MASTER_KNOWLEDGE
                }
            });
            break;
        case Constant.TICKET_TYPE.KNOWLEDGE:
            argsCommon.addNewPanel({
                type: Constant.PANEL_TYPE.KNOWLEDGE_TICKET_DETAIL,
                tabId: `${Constant.PANEL_TYPE.KNOWLEDGE_CREATE_TICKET}_${Date.now().toString()}`,
                props: {
                    ...propsClone,
                    createTicketType: Constant.TICKET_TYPE.KNOWLEDGE
                }
            });
            break;
        default:
            break;
    }
};

/**
 * isDisplayEyeSlashIcon
 * @param {*} isCustomer
 * @param {*} ticketDetail
 */
export const isDisplayEyeSlashIcon = (isCustomer, visibility, ticketDetail) => {
    if (
        isCustomer ||
        visibility !== Constant.VISIBILITY_SETTING_TYPE.CUSTOMER ||
        Utils.isEmptyObject(ticketDetail)
    )
        return false;

    if (
        ticketDetail.publicAll === Constant.KNOWLEDGE_RANGE.PUBLIC &&
        [
            Constant.KNOWLEDGE_CHAT_PERMISSION.PUBLIC,
            Constant.KNOWLEDGE_CHAT_PERMISSION.BY_VIEW_PERMISSION
        ].includes(ticketDetail.chatPermission)
    ) {
        return false;
    }

    return true;
};

/**
 * Check user has view chat thread permission after update ticket
 * return true if user has permission
 * @param {*} ticket
 * @param {*} projectInuseDetail
 * @returns
 */
export const hasKnowledgeChatPermissionInChatThread = (
    ticket,
    projectInuseDetail,
    userId,
    isOnlyCheckView = false,
    currentProjectB2BCustomerIdList = [],
    currentProjectB2BHelpdeskIdList = [],
) => {
    let isHasViewPermission = false;

    if (!ticket?.viewPermission?.length) return false;
    // check is creator
    if (userId === ticket.creator) return true;
    const viewPermission = ticket?.viewPermission;
    const listB2BCustomer = ticket?.activeB2BCustomerList || [];
    const listB2BHelpdesk = ticket?.activeB2BSupportList || [];

    const additionalViewPermission = Utils.convertJSONDataToObject(
        ticket?.additionalViewPermission
    );
    if (!Utils.isEmptyObject(additionalViewPermission)) {
        for (let [_, value] of Object.entries(additionalViewPermission)) {
            if (value.includes(projectInuseDetail?.id)) {
                isHasViewPermission = true;
                break;
            }
        }
    }
    if (
        viewPermission.includes(Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.CREATOR_ONLY) &&
        !isHasViewPermission
    ) {
        isHasViewPermission =
            userId === ticket.creator && projectInuseDetail?.id === ticket.affiliationProject;
    }
    if (
        viewPermission.includes(Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.B2B_CUSTOMER) &&
        !isHasViewPermission
    ) {
        isHasViewPermission =
            listB2BCustomer.includes(ticket.affiliationProject) ||
            listB2BCustomer.includes(projectInuseDetail?.id);

        if (!isHasViewPermission && !Utils.isEmptyArray(currentProjectB2BHelpdeskIdList)) {
            isHasViewPermission = currentProjectB2BHelpdeskIdList.includes(ticket.affiliationProject)
        }
    }
    if (
        viewPermission.includes(Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.B2B_SUPPORT) &&
        !isHasViewPermission
    ) {
        isHasViewPermission =
            listB2BHelpdesk.includes(ticket.affiliationProject) ||
            listB2BHelpdesk.includes(projectInuseDetail?.id);

        if (!isHasViewPermission && !Utils.isEmptyArray(currentProjectB2BCustomerIdList)) {
            isHasViewPermission = currentProjectB2BCustomerIdList.includes(ticket.affiliationProject)
        }
    }
    if (
        viewPermission.includes(Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.IN_PROJECT) &&
        !isHasViewPermission
    ) {
        isHasViewPermission = ticket.affiliationProject === projectInuseDetail.id;
    }

    // Remove base prj can view in org
    if (
        viewPermission.includes(Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.IN_ORG) &&
        !isHasViewPermission
    ) {
        isHasViewPermission =
            ticket.affiliationOrganization === projectInuseDetail.affiliationOrganization &&
            ![Constant.PROJECT_TYPE.CUSTOMER].includes(
                projectInuseDetail.type
            );
    }
    if (
        viewPermission.includes(Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.PUBLIC) &&
        !isHasViewPermission
    ) {
        isHasViewPermission = true;
    }

    if (isOnlyCheckView) return isHasViewPermission;

    if (isHasViewPermission) {
        return hasKnowledgeChatPermission(ticket, projectInuseDetail);
    }

    return isHasViewPermission;
};

/**
 * hasKnowledgeChatPermission
 * @param {*} ticket
 * @param {*} projectInuseDetail
 * @returns
 */
export const hasKnowledgeChatPermission = (ticket, projectInuseDetail) => {
    let chatPermission = false;
    if (!ticket.chatPermission) return false;

    if (![Constant.TICKET_TYPE.KNOWLEDGE, Constant.TICKET_TYPE.MASTER_KNOWLEDGE].includes(ticket.ticketType)) {
        return false;
    }

    switch (ticket.chatPermission) {
        case Constant.KNOWLEDGE_CHAT_PERMISSION.NO:
            break;
        case Constant.KNOWLEDGE_CHAT_PERMISSION.IN_PROJECT:
            chatPermission = ticket.affiliationProject === projectInuseDetail.id;
            break;
        case Constant.KNOWLEDGE_CHAT_PERMISSION.IN_ORG:
            chatPermission =
                ticket.affiliationOrganization === projectInuseDetail.affiliationOrganization &&
                ![Constant.PROJECT_TYPE.BASE, Constant.PROJECT_TYPE.CUSTOMER].includes(
                    projectInuseDetail.type
                );
            break;
        case Constant.KNOWLEDGE_CHAT_PERMISSION.PUBLIC:
        case Constant.KNOWLEDGE_CHAT_PERMISSION.BY_VIEW_PERMISSION:
            chatPermission = true;
            break;
        default:
            break;
    }

    return chatPermission;
};

export const getVisibleWidth = elements => {
    const container = document.getElementById('container-knowledge');
    let containerRect = container.getBoundingClientRect();
    let eleRect = elements.getBoundingClientRect();
    let rect = {};
    rect.top = eleRect.top - containerRect.top;
    rect.right = eleRect.right - containerRect.right;
    rect.bottom = eleRect.bottom - containerRect.bottom;
    rect.left = eleRect.left - containerRect.left;
    rect.width = eleRect.width;

    return rect;
};

let timeoutEvent;
export const onWheel = (event, element, nodeListView, tabs) => {
    element.scrollLeft +=
        event.deltaY > 0 ? Constant.SCROLL_LEFT_CHANGE : Constant.SCROLL_LEFT_CHANGE * -1;
    event.stopPropagation();
    let containerRect = element.getBoundingClientRect();

    let posElem = [];
    for (let i = 0; i < nodeListView.length; i++) {
        let id = tabs[i]?.id;
        // Gets the amount of pixels currently visible within the container
        let visiblePageWidth = getVisibleWidth(nodeListView[i]);
        posElem.push({ id: id, pos: visiblePageWidth });
    }

    // trigger wheel end
    if (timeoutEvent) clearTimeout(timeoutEvent);
    timeoutEvent = setTimeout(() => {
        for (let i = 0; i < posElem.length; i++) {
            let item = posElem[i];
            // Find first view that has entered viewport and hasn't scrolled too far
            // Threshold: view left is within SNAP_SCROLL_THRESHOLD of container width from start
            if (item.pos.left >= 0 && item.pos.left < containerRect.width * Constant.SNAP_SCROLL_THRESHOLD) {
                // Snap to align this view at container start
                element.scrollLeft += item.pos.left;
                break;
            }
        }
    }, Constant.TRIGGER_TIMEOUT_WHEEL_END);
};

export const onTouchEnd = (event, element, nodeListView, tabs) => {
    let containerRect = element.getBoundingClientRect();
    if (timeoutEvent) clearTimeout(timeoutEvent);
    let posElem = [];
    for (let i = 0; i < nodeListView.length; i++) {
        let id = tabs[i].id;
        // Gets the amount of pixels currently visible within the container
        let visiblePageWidth = getVisibleWidth(nodeListView[i]);
        posElem.push({ id: id, pos: visiblePageWidth });
    }

    // Apply same logic as onWheel for consistency
    for (let i = 0; i < posElem.length; i++) {
        let item = posElem[i];
        // Find first view that has entered viewport and hasn't scrolled too far
        // Threshold: view left is within SNAP_SCROLL_THRESHOLD of container width from start
        if (item.pos.left >= 0 && item.pos.left < containerRect.width * Constant.SNAP_SCROLL_THRESHOLD) {
            // Snap to align this view at container start
            element.scrollLeft += item.pos.left;
            break;
        }
    }
};

export const onTouchCancel = (event, element, nodeListView, tabs) => {
    // Apply same logic as onTouchEnd for consistency
    onTouchEnd(event, element, nodeListView, tabs);
};

/**
 * permissionChangeShareRangeStatus
 * @param {*} ticketDetail
 * @param {*} userDetail
 * @param {*} userProjectList
 * @returns
 */
export const permissionChangeShareRangeStatus = (ticketDetail, userDetail, isProjectManager, projectInuseDetail, viewStructure = null) => {
    if (Utils.isEmptyObject(projectInuseDetail) || viewStructure?.ticketProperty == Constant.TICKET_PROPERTY.SYNONYM) return false;

    if (ticketDetail?.isSynonym && viewStructure?.ticketProperty == Constant.TICKET_PROPERTY.DRAFT) {
        return false;
    }

    if (![Constant.TICKET_TYPE.KNOWLEDGE, Constant.TICKET_TYPE.MASTER_KNOWLEDGE].includes(ticketDetail.ticketType)) {
        return false;
    }

    let ticketAffiliationProjectId = ticketDetail.affiliationProject;
    
    if (isProjectManager && ticketAffiliationProjectId === projectInuseDetail.id) {
        return true;
    }

    return false;
};

/**
 * getListTicketKnowledge
 * @param {*} argsCommon 
 * @param {*} paginationFrom 
 * @param {*} paginationSize 
 */
export const getListTicketKnowledge = (
    argsCommon, 
    paginationFrom, 
    paginationSize, 
    lastUserAction, 
    currentCorporationDetail, 
    projectInuseDetail, 
    userDetail, 
    searchContentType, 
    searchTagSuggest,
    removedTagItem, 
    setRemovedTagItem
) => {
    const drillDownSearch = buildDrillDownSearchParam(argsCommon?.viewStructure);
    
    drillDownSearch.ticketCreatedProjectId = argsCommon.destinationPrjId;

    let searchVisibility = argsCommon?.viewStructure?.visibility
        ? argsCommon?.viewStructure?.visibility
        : argsCommon?.visibilityKnowledgeAtom;
    if ([Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK].includes(currentCorporationDetail.contractType) && argsCommon.corporationSelectedId !== currentCorporationDetail?.id) {
        searchVisibility = Constant.VISIBILITY_SETTING_TYPE.CUSTOMER;
    }

    if ([Constant.CORPORATION_CONTRACT_TYPE.GUEST].includes(currentCorporationDetail.contractType) || Utils.isB2CUser(userDetail)) {
        searchVisibility = Constant.VISIBILITY_SETTING_TYPE.CUSTOMER;
    }

    if (!searchVisibility) {
        searchVisibility = Constant.VISIBILITY_SETTING_TYPE.PRIVATE;
    }

    handleSearchTicketKnowledge(
        argsCommon,
        argsCommon?.corporationSelectedId,
        searchVisibility,
        drillDownSearch,
        paginationFrom,
        paginationSize,
        lastUserAction,
        currentCorporationDetail,
        projectInuseDetail,
        userDetail,
        searchContentType,
        searchTagSuggest,
        removedTagItem, 
        setRemovedTagItem
    )
        .then(async dataList => {
            
            if (argsCommon?.viewStructure.keyword !== argsCommon?.keywordSearch) {
                argsCommon?.setKeywordSearch(argsCommon?.viewStructure.keyword);
            }
            for (let data of dataList) {
                if (!Utils.isEmptyArray(data.footPrint)) {
                    data.footPrint = data.footPrint.reverse();
                }
                // TODO: Refactor code next sprint
                if (!Utils.isEmptyArray(data.footPrintDetail)) {
                    data.footPrintDetail = await Promise.all(
                        data.footPrintDetail.map(async user => {
                            let avatar = Constant.AVATAR_DEFAULT;
                            if (!Utils.isEmptyString(user.avatar)) {
                                try {
                                    avatar = await Storage.get(user.avatar);
                                } catch (err) {
                                    avatar = Constant.AVATAR_DEFAULT;
                                }
                            }
                            user.avatar = avatar;
                            return user;
                        })
                    );
                }
            }
            
            const paginationClone = { ...argsCommon.pagination };
            let mergeTicketList =
                paginationFrom > 0 ? argsCommon?.ticketKnowledgeList?.concat(dataList) : dataList;
            
            argsCommon?.setTicketKnowledgeList(mergeTicketList);

            paginationClone.lastTotal =
                dataList.length >= Constant.TICKET_LIST_PAGINATION_DEFAULT_RECORD
                    ? Constant.TICKET_LIST_PAGINATION_DEFAULT_RECORD
                    : dataList.length;
            paginationClone.from = paginationFrom;
            paginationClone.size = paginationSize;
            argsCommon.setPagination(paginationClone); 
            await getDrilldownDataSelected(argsCommon?.API, argsCommon?.viewStructure, argsCommon?.setDrillDownDataSelected);
        })
        .catch(() => {
            argsCommon?.setIsLoading(false);
        })
        .finally(() => {
            argsCommon?.setIsLoading(false);
        });
}

/**
 * 1. Reload list ticket every minute
 * @param {*} argsCommon 
 */
export const autoReloadTicket = async argsCommon => {
    argsCommon?.setIsLoading(true);
    const paginationFrom = 0;
    const paginationSize =
    argsCommon?.ticketKnowledgeList?.length > Constant.TICKET_LIST_PAGINATION_DEFAULT_RECORD
            ? argsCommon?.ticketKnowledgeList?.length
            : Constant.TICKET_LIST_PAGINATION_DEFAULT_RECORD;
    getListTicketKnowledge(argsCommon, paginationFrom, paginationSize, false, argsCommon.corporationDetail);
};

export const isCheckMethodSimilar = (viewStructure) => {
    let options = viewStructure.options;
    for (let key in options) {
        if (
            options.hasOwnProperty(key) &&
            key === Constant.METHOD &&
           options[key] === Constant.SETTING_SEARCH_KEYWORD.SIMILAR
        ) {
            return true;
        }
    }
    return false;
}

export const isCheckSortPageNo = viewStructure => {
    let options = viewStructure.options;
    if (options['sort'] === Constant.DRILLDOWN_SEARCH_OPTION_SORT_TYPE.PAGE_NO){
        return true;
    }

    return false;
};

export const isViewAllKnowledgeInCorporation = (organizationProject) => {
    return organizationProject.value === Constant.KNOWLEDGE_VIEW_OPTION.ALL_KNOWLEDGE_IN_ORG;
}

export const displayTagOfThumbAttach = (ticketDetail, filename, isFileInPdf = false) => {  
    if (ticketDetail.ticketType === Constant.TICKET_TYPE.PDF_PAGE_KNOWLEDGE) {
        return {
            name: ListTicketKnowledgeConstant.EXT_FILE_PAGE_KNOWLEDGE.DISPLAY,
            colorCode: ListTicketKnowledgeConstant.EXT_FILE_PAGE_KNOWLEDGE.COLOR_DISPLAY,
        };
    }

    if (isFileInPdf) {
        return {
            name: ListTicketKnowledgeConstant.EXT_FILE_PAGE_KNOWLEDGE.DISPLAY,
            colorCode: ListTicketKnowledgeConstant.EXT_FILE_PAGE_KNOWLEDGE.COLOR_DISPLAY,
        };
    }
  
    const extFile = filename?.split(".")?.pop()?.toLowerCase();
    
    for (const fileType of ListTicketKnowledgeConstant.LIST_EXT_FILE) {
        if (fileType.LIST.includes(extFile)) {
            return { name: fileType.DISPLAY, colorCode: fileType.COLOR_DISPLAY };
        }
    }

    return {
        name: ListTicketKnowledgeConstant.EXT_FILE_OTHER.DISPLAY,
        colorCode: ListTicketKnowledgeConstant.EXT_FILE_OTHER.COLOR_DISPLAY,
    };
  };

export const handleSelectFilePdf = async (
    setPreviousViewStructure,
    setViewStructure,
    viewStructure,
    ticketDetail,
    fileInfo,
    isCustomer,
    setFileNamePdfSelect,
    setTriggerSearch,
    fileNamePdfSelect,
    corporationId,
    API,
    setIsOpenModalReloadPage,
    setIsLoading
) => {
    setIsLoading(true);
    const newCorporationInfo = await getCorporationById(API, corporationId);
    if (Utils.isEmptyObject(newCorporationInfo)) {
        setIsLoading(false);
        setIsOpenModalReloadPage(true);
        return;
    }

    let corporationLimitValue = newCorporationInfo.limitValue;
    let inviterLimitValue = newCorporationInfo.inviterSetting
        ? Utils.convertJSONDataToObject(newCorporationInfo.inviterSetting)
        : {};

    if (
        (corporationLimitValue?.convertPDF === Constant.PDF_FUNCTION.OFF &&
            [Constant.CORPORATION_CONTRACT_TYPE.PREMIUM].includes(
                newCorporationInfo.contractType
            )) ||
        inviterLimitValue?.convertPDF === Constant.PDF_FUNCTION.OFF
    ) {
        setIsLoading(false);
        setIsOpenModalReloadPage(true);
        return;
    }

    if (fileNamePdfSelect) {
        setFileNamePdfSelect(fileInfo.fileName);
        setIsLoading(false);
        return;
    }

    let originStructure = isCustomer
        ? {
              ...Constant.DEFAULT_VIEW_STRUCTURE,
              visibility: Constant.VISIBILITY_SETTING_TYPE.CUSTOMER
          }
        : Constant.DEFAULT_VIEW_STRUCTURE;
    let newViewStructure = cloneDeep(originStructure);

    setPreviousViewStructure(viewStructure);
    newViewStructure.options['sort'] = Constant.DRILLDOWN_SEARCH_OPTION_SORT_TYPE.PAGE_NO;
    newViewStructure.options['getListPdfPage'] = 1;
    if (
        ticketDetail.ticketType === Constant.TICKET_TYPE.KNOWLEDGE ||
        ticketDetail.ticketType === Constant.TICKET_TYPE.MASTER_KNOWLEDGE
    ) {
        newViewStructure.options['filePdfId'] = fileInfo.idTicketFileKnowledge;
    }
    if (ticketDetail.ticketType === Constant.TICKET_TYPE.PDF_FILE_KNOWLEDGE) {
        newViewStructure.options['filePdfId'] = ticketDetail.id;
    }

    if (ticketDetail.ticketType === Constant.TICKET_TYPE.PDF_PAGE_KNOWLEDGE) {
        newViewStructure.options['filePdfId'] = ticketDetail.parent;
    }

    setViewStructure(newViewStructure);
    setTriggerSearch(Date.now().toString());

    setFileNamePdfSelect(fileInfo.fileName);
};

export const getPreviousViewStructureDefault = (knowledgeInfoChatAi, viewStructure) => {
    let viewStructureClone = cloneDeep(viewStructure)
    if(!Utils.isEmptyObject(knowledgeInfoChatAi)) {
        let options = viewStructureClone.options;
        if(options.filePdfId) {
            delete options.filePdfId;
            delete options.sort;
            delete options.getListPdfPage;
            viewStructureClone.options = options;
        }
    }
    
    return viewStructureClone;
}

export const isDisplayIconSearchFileAndPageKnowledge = (corporationDetail, viewStructure, parentPanel) => {
    if (parentPanel !== Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST) {
        return false;
    }
    if(viewStructure.ticketProperty === Constant.TICKET_PROPERTY.SYNONYM) {
        return false;
    }
    if (!Utils.isEmptyString(viewStructure?.options?.filePdfId)) {
        return false;
    }
    
    let corporationLimitValue = corporationDetail.limitValue;
    let inviterLimitValue = corporationDetail.inviterSetting
        ? Utils.convertJSONDataToObject(corporationDetail.inviterSetting)
        : {};
    return (
        (corporationLimitValue?.convertPDF === Constant.PDF_FUNCTION.ON ||
            inviterLimitValue.convertPDF === Constant.PDF_FUNCTION.ON) &&
        viewStructure?.options?.attribute !== Constant.SETTING_SEARCH_KEYWORD.COMMENT
    );
};

const getDataCorpAndProjectForLog = (corporationSelectedId, projectSelectedId, organizationProject, corporationDetail, projectInuseDetail) => {
    let desCorp = {
        id: corporationDetail.id,
        organizationDomain: corporationDetail.organizationDomain,
        organizationName: corporationDetail.corporationName,
    }
    let desPrj = {
        id: projectInuseDetail.id,
        name: Utils.convertJSONDataToObject(projectInuseDetail.name)?.jp.text,
    }

    if (corporationSelectedId !== corporationDetail.id) {
        let externalData = organizationProject.externalProjectList.find(corp => corp.corpId === corporationSelectedId);
        if (externalData) {
            desCorp = {
                id: corporationSelectedId,
                organizationDomain: externalData.organizationDomain,
                organizationName: Utils.convertJSONDataToObject(externalData.organizationName)?.jp.text,
            }
            desPrj = {
                id: externalData.id,
                name: externalData.name,
            }
        }
    }
    
    if (projectSelectedId !== projectInuseDetail.id) {
        let internalData = organizationProject.internalProjectList.find(prj => prj.id === projectSelectedId);
        if (internalData) {
            desPrj = {
                id: projectSelectedId,
                name: internalData.label,
            }
        }
    }

    return { desCorp, desPrj }
}

export const handleMsgDialogConfirmByBulkAction = (actionType, formSelectedInSearchConditionDetail, isCurrentProjectUsingFormSelected) => {
    switch (actionType) {
        case Constant.BULK_ACTION.EDIT_TAG_FIELD:
            return '';
        case Constant.BULK_ACTION.EDIT_PUBLIC_RANGE:
            return '';
        case Constant.BULK_ACTION.EXPORT_CSV:
        case Constant.BULK_ACTION.HELPDESK_EXPORT_CSV:
            return 'MSG-CM-CONFIRM-EXPORT-CSV';
        case Constant.BULK_ACTION.BACK_TO_DRAFT:
            return 'MSG-KNOW-CONFIRM-BACK-TO-DRAFT-MULTI-CONTENTS';
        case Constant.BULK_ACTION.SENT_TO_PUBLIC:
            return 'MSG-CM-CONFIRM-SEND-TO-PUBLIC-CONTENT';
        case Constant.BULK_ACTION.DUPLICATE:
            if (!formSelectedInSearchConditionDetail) {
                return 'MSG-KNOW-FORM-NOT-SHARE';
            }
            if (!isCurrentProjectUsingFormSelected) {
                return 'MSG-KNOW-CONFIRM-MOVE-FORM-DUPLICATE';
            }
            return 'MSG-KNOW-CONFIRM-DUPLICATE-MULTI-CONTENT';
            
        case Constant.BULK_ACTION.SOFT_DELETE:
        case Constant.BULK_ACTION.HELPDESK_SOFT_DELETE:
            return 'MSG-CM-CONFIRM-DELETE-MULTI-CONTENT';
        case Constant.BULK_ACTION.HARD_DELETE:
        case Constant.BULK_ACTION.HELPDESK_HARD_DELETE:
            return 'MSG-CM-CONFIRM-DELETE-PERMANENTLY-MULTI-CONTENT';
        case Constant.BULK_ACTION.RESTORE:
        case Constant.BULK_ACTION.HELPDESK_RESTORE:
            return 'MSG-CM-CONFIRM-RESTORE-MULTI-CONTENT';
        case Constant.BULK_ACTION.HELPDESK_ARCHIVE:
            return 'MSG-CM-CONFIRM-ARCHIVE-MULTI-CONTENT';
        case Constant.BULK_ACTION.HELPDESK_BACK_TO_NEW_SUPPORT:
            return 'MSG-CM-CONFIRM-BACK-TO-NEW-MULTI-CONTENT';
        default:
            return '';
    }
}

/**
 * 
 * @param {*} actionType 
 * @param {*} status // it's enable or disable
 * @returns 
 */
export const handleStatusBulkActionTooltipMsg = (actionType, status = false) => {
    switch (actionType) {
        case Constant.BULK_ACTION.EDIT_TAG_FIELD:
            if(status) return ''
            return 'MSG-KNOW-TOOLTIP-WHEN-DISABLE-EDIT-TAG-FIELD';
        case Constant.BULK_ACTION.EDIT_PUBLIC_RANGE:
            if(status) return ''

            return '';
        case Constant.BULK_ACTION.EXPORT_CSV:
            if (status) return 'MSG-KNOW-TOOLTIP-WHEN-ENABLE-ICON-EXPORT-CSV'
            
            return 'MSG-KNOW-TOOLTIP-WHEN-DISABLE-ICON-EXPORT-CSV';
        case Constant.BULK_ACTION.BACK_TO_DRAFT:
            if (!status) return 'MSG-KNOW-TOOLTIP-DISABLE-BACK-TO-DRAFT';
            return '';
        case Constant.BULK_ACTION.SENT_TO_PUBLIC:
            return '';
        case Constant.BULK_ACTION.DUPLICATE:
            if(status) return '';
            return 'MSG-KNOW-TOOLTIP-WHEN-DISABLE-ACTION-DUPLICATE';
        case Constant.BULK_ACTION.DELETE:
        case Constant.BULK_ACTION.HARD_DELETE:
        case Constant.BULK_ACTION.RESTORE:
            if (!status) return 'MSG-KNOW-TOOLTIP-BULK-ACTION';
            return '';
        default:
            return '';
    }
}

export const handleMsgPendingWhenBulkActionInProcessing= (actionType) => {
    switch (actionType) {
        case Constant.BULK_ACTION.EXPORT_CSV:
        case Constant.BULK_ACTION.EDIT_TAG_FIELD:
        case Constant.BULK_ACTION.EDIT_PUBLIC_RANGE:
        case Constant.BULK_ACTION.BACK_TO_DRAFT:
        case Constant.BULK_ACTION.SENT_TO_PUBLIC:
        case Constant.BULK_ACTION.SOFT_DELETE:
        case Constant.BULK_ACTION.HARD_DELETE:
        case Constant.BULK_ACTION.RESTORE:
        case Constant.BULK_ACTION.DUPLICATE:
        case Constant.BULK_ACTION.HELPDESK_DELETE:
        case Constant.BULK_ACTION.HELPDESK_SOFT_DELETE:
        case Constant.BULK_ACTION.HELPDESK_HARD_DELETE:
        case Constant.BULK_ACTION.HELPDESK_RESTORE:
        case Constant.BULK_ACTION.HELPDESK_EXPORT_CSV: // helpDesk actions in below
        case Constant.BULK_ACTION.HELPDESK_ARCHIVE:
        case Constant.BULK_ACTION.HELPDESK_BACK_TO_NEW_SUPPORT:
        case Constant.BULK_ACTION.HELPDESK_EDIT_TAG_FIELD:
            return 'MSG-KNOW-BULK-ACTION-LOADING';
        default:
            return '';
    }

    // case Constant.BULK_ACTION.HELPDESK_BACK_TO_DRAFT:
    //     case Constant.BULK_ACTION.HELPDESK_SENT_TO_PUBLIC:
}

export const handleTxtSubmitAndCancelActionPopup = actionType => {
    let result = {
        submit: 'CM-BUTTON-OK',
        cancel: 'CM-BUTTON-CANCEL'
    };
    return result;
};

/**
 * permissionShowOptionMultiShareRange
 * @param {*} isProjectManager
 * @param {*} projectInuseDetail
 * @param {*} viewSelected
 * @returns
 */
export const permissionShowOptionMultiShareRange = (projectList, destinationPrjId) => {
    if (!projectList || !destinationPrjId || Utils.isEmptyArray(projectList)) return false;
    let targetProjectUserPermission = projectList.find(project => project?.id === destinationPrjId);
    if (targetProjectUserPermission && targetProjectUserPermission.isProjectManager) {
        return true;
    }

    return false;
};

export const isShowFormEditRangeMulti = (projectList, destinationPrjId, totalTicket = 0, isShowEditPublicRange, selectedProject) => {
    let hasPermission = permissionShowOptionMultiShareRange(projectList, destinationPrjId);

    return totalTicket > 0 && hasPermission && isShowEditPublicRange && destinationPrjId;
}

export const handleBulkUpdateTicketAPI = (
    isOpenDialogConfirm,
    setIsOpenDialogConfirm,
    setBulkActionTaskId,
    setDisableButtonCallBack,
    enqueueSnackbar,
    setIsShowDialogReload
) => {
    if(setIsOpenDialogConfirm) {
        setIsOpenDialogConfirm({
            status: false,
            action: '',
            params: {}
        });
    }
    
    setBulkActionTaskId('loading...');

    const params = isOpenDialogConfirm.params;
    handleBulkUpdateTicket(params)
        .then(data => {
            let errorMsg;
            switch (data.status) {
                case 200:
                    setBulkActionTaskId(data.taskId);
                    break;
                case 500:
                    if (data.message === 'COMMSG030') {
                        setIsShowDialogReload(true)
                        break
                    }
                    errorMsg = I18n.get('SYSMSG001');
                    if (
                        [
                            Constant.BULK_ACTION.EXPORT_CSV,
                            Constant.BULK_ACTION.HELPDESK_EXPORT_CSV
                        ].includes(isOpenDialogConfirm?.action)
                    )
                        errorMsg = I18n.get('MSG-CM-OTHERS-ERROR-WHEN-EXPORT-CSV');

                    enqueueSnackbar(errorMsg, {
                        variant: 'error',
                        autoHideDuration: 3000
                    });
                    setBulkActionTaskId('');
                    break;
                default:
                    if (
                        [
                            Constant.BULK_ACTION.EXPORT_CSV,
                            Constant.BULK_ACTION.HELPDESK_EXPORT_CSV
                        ].includes(isOpenDialogConfirm?.action)
                    ) {
                        const [errors] = data?.errors;
                        if (errors?.message == 'Network Error')
                            errorMsg = I18n.get('MSG-CM-DISCONNECT-NETWORK-WHEN-EXPORT-CSV');
                        enqueueSnackbar(errorMsg, {
                            variant: 'error',
                            autoHideDuration: 3000
                        });
                        setBulkActionTaskId('');
                    }
                    break;
            }
        })
        .catch(err => {
            console.log('err', err);
            let errorMsg = I18n.get('SYSMSG001');

            if (isOpenDialogConfirm?.action == Constant.BULK_ACTION.EXPORT_CSV) {
                errorMsg = I18n.get('MSG-CM-OTHERS-ERROR-WHEN-EXPORT-CSV');
            }

            enqueueSnackbar(errorMsg, {
                variant: 'error',
                autoHideDuration: 3000
            });
            setBulkActionTaskId('');
        })
        .finally(() => {
            if (setDisableButtonCallBack) {
                setDisableButtonCallBack(false);
            }
            document.body.style.cursor='default';
        })
};

const getTitle = (settingTitle) =>{
    let title = '';
    settingTitle?.forEach(element => {
        if(!element.isBreak){
            title = title +element.text
        }
    })
    return title
}

const getItemListOfMasterField = async (
    orgId,
    projectId,
    formId,
    structure,
    userDetail,
    projectInuseDetail,
    corporationDetail
) => {
    let listTicketChild = await queryListMasterKnowledgeItemWithShortenedData(
        orgId,
        projectId,
        formId,
        {
            userId: userDetail.id,
            projectInuse: projectInuseDetail.id,
            organizationInuse: corporationDetail.id
        }
    );
    
    let itemTagList = [];
    listTicketChild?.forEach(ticket => {
        let currentItem = structure?.listItem?.find(o => o.itemId === ticket.id);
        let isActive = !!(currentItem?.isActive && Utils.isEmpty(ticket?.deletedAt));
        if (!Utils.isEmptyObject(currentItem)) {
            let itemData = {
                name: { jp: { text: getTitle(ticket.settingTitle) } },
                id: ticket.id,
                isDeleted: !Utils.isEmpty(ticket?.deletedAt),
                structure: {
                    hitNumber: Utils.isEmpty(currentItem) ? 0 : currentItem.hitNumber,
                    no: Utils.isEmpty(currentItem) ? 1 : currentItem.order,
                    isShowItemInTicket: isActive
                },
                isTagMaster: true
            };

            if (currentItem.isActive && !itemData.isDeleted) {
                itemTagList.push(itemData);
            }
        }
    });

    return itemTagList;
};

export const getListTagFieldOfForm = async ({
    formId,
    userDetail,
    projectInuseDetail,
    corporationDetail,
    setSelectedFilterForm,
    affiliationProjectId,
    isProjectManager,
    viewStructure
}) => {
    const [listFieldInform, formDetail] = await Promise.all([
        getListFieldInFieldByFormId(formId),
        getFormById(API,formId)
    ]);

    if(setSelectedFilterForm){
        setSelectedFilterForm(formDetail)
    }

    const formStructure = Utils.convertJSONDataToObject(formDetail.structure);

    let listFieldStructure = Object.values(formStructure);
    let listFieldInForm = listFieldStructure?.map(fieldStructure => {
        if (fieldStructure.field) return fieldStructure.field;
        return null
    });
    listFieldInForm = listFieldInForm?.filter(fieldId => fieldId );

    let listFiledIdRequire = listFieldStructure?.map(fieldStructure => {
        if (!Utils.isEmptyString(fieldStructure.field) && fieldStructure.required) {
            return fieldStructure.field
        }
        return null
    });

    listFiledIdRequire = listFiledIdRequire?.filter(fieldId => fieldId );

    // For AI Assistant Prompt form, allow ai_telephone_trigger_condition and ai_telephone_execution_scope
    const isAIAssistantPromptForm = Utils.isSystemFormAIAssistantPrompt(formDetail);
    const effectiveIgnoreList = isAIAssistantPromptForm
        ? IgnoreBulkActionField.filter(f => ![
            Constant.SYSTEM_FIELD.AI_TELEPHONE_TRIGGER_CONDITION,
            Constant.SYSTEM_FIELD.AI_TELEPHONE_EXECUTION_SCOPE,
        ].includes(f))
        : IgnoreBulkActionField;

    let listTagField = listFieldInform?.filter(field => (
        field.type === Constant.FORM_TYPE.FIELD_TAG &&
        !effectiveIgnoreList.includes(field?.sysField) && // skip system ai field (with AI Assistant Prompt exemption)
        (AutoPassForBulkAction.includes(field?.sysField) || field?.usingProjects?.includes(affiliationProjectId))
    ));

    if (Utils.isSystemTelephoneForm(formDetail)) {
        if (viewStructure?.ticketProperty === Constant.TICKET_PROPERTY.TRAINING) {
            listTagField = listTagField.filter(field =>
                !TelephoneConstant.TELEPHONE.HIDDEN_FIELDS_FOR_TRAINING_CALL.includes(field?.sysField)
            );
        }
    }

    if (Utils.isSystemSDAutoForm(formDetail) && !isProjectManager) {
        // if is not PM in prjInuse , can not action SDAutoApiSetting
        listTagField = listTagField.filter(field => ![
                Constant.SYSTEM_FIELD.SDAUTO_CALL_SCRIPT_API_SETTING,
                Constant.SYSTEM_FIELD.SDAUTO_CALL_SCRIPT_API_SETTING_TARGET
            ].includes(field.sysField)
        )
    }
  
    if (!Utils.isEmptyArray(listTagField)) {
        let getListItemOfTagFieldProcessList = [];
        listTagField?.forEach(field => {
            if (!Utils.isEmptyString(field.relatedMasterForm) && field.relatedMasterForm !== 'NULL' && field.relatedMasterForm !== 'null') {
                getListItemOfTagFieldProcessList.push(getItemListOfMasterField(field.affiliationOrganization,field.affiliationProject,field.relatedMasterForm,Utils.convertJSONDataToObject(field.structure),userDetail,projectInuseDetail,corporationDetail))
            } else {
                getListItemOfTagFieldProcessList.push(queryTagChildWithShortenedData(field.affiliationOrganization, field.id, field));
            }
        });
        const listItemResult = await Promise.all(getListItemOfTagFieldProcessList);

        listTagField = listTagField?.map((field,index) => {
            if (!field || Utils.isEmptyObject(field)) return null;
            if (
                field.usage === Constant.FORM_USAGE.FIELD &&
                field.type === Constant.FORM_TYPE.FIELD_TAG
            ) {
                let formsUsingField = Utils.convertJSONDataToObject(field.usingForms) || {};
                if (!formsUsingField.hasOwnProperty(formId) || !formsUsingField[formId].active)
                    return null;
            }

            field.listItem = listItemResult[index];

            if (
                field.sysField === Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER &&
                !Utils.isEnableUsingTelephoneMode(corporationDetail, projectInuseDetail)
            ) {
                field.listItem = (field.listItem || []).filter(tagItem =>
                    tagItem?.sysField !== Constant.AI_AUTO.SYSTEM_FIELD.EVENT_TRIGGER_CALL_COMPLETED
                )
            }

            let fieldStructure = Utils.convertJSONDataToObject(field.structure)
            field.isMultiple = fieldStructure.isMultiple
            if (listFiledIdRequire.includes(field.id)) {
                field.required = true
            };

            let indexFiledInfo = listFieldInForm?.findIndex(fieldInfoId => fieldInfoId === field.id)
            field.no = indexFiledInfo;

            return field
        })
    }

    listTagField = listTagField.filter(field => field);
    
    listTagField = Utils.sortDrillDownByNo(listTagField).map(tagField => {
        const clonedTagField = {...tagField}
        let listItem = [...clonedTagField.listItem]
        listItem = listItem.filter(item => item.structure.isShowItemInTicket) // check item is active

        return {
            ...clonedTagField,
            listItem: [...listItem]
        }
    })

    return listTagField
  }

  /**
 * getDataPublicRange
 * @param {*} argsCommon
 * @param {*} filterParams
 * @returns
 */
export const getDataPublicRange = async (argsCommon, filterParams) => {
    argsCommon?.setIsLoadDataForPublicRangeDone(false);
    let queryData = await getDataPublicRangePagination(argsCommon, filterParams);
    let listData = Utils.convertJSONDataToObject(queryData);
    argsCommon?.setIsLoadDataForPublicRangeDone(true);
    return { dataPublicRange: listData };
};

/**
 * getDataPublicRangePagination
 * @param {*} argsCommon
 * @param {*} filterParams
 * @param {*} drillDown
 * @returns
 */
export const getDataPublicRangePagination = async (argsCommon, filterParams) => {
    const queryData = await getPublicRangeData(argsCommon.API, filterParams);
    let listData = Utils.convertJSONDataToObject(queryData?.data);
    let listDataPublicRange = listData;

    let valueDefault = {
        listBasicViewCommon: [],
        listBasicViewOther: [],
        listBasicEditCommon: [],
        listBasicEditOther: [],
        listAdditionalViewCommon: {},
        listAdditionalViewOther: {},
        listAdditionalEditCommon: {},
        listAdditionalEditOther: {}
    }
    if (listDataPublicRange?.listBasicViewCommon) {
        valueDefault.listBasicViewCommon = listDataPublicRange?.listBasicViewCommon
    }
    if (listDataPublicRange?.listBasicViewOther) {
        valueDefault.listBasicViewOther = listDataPublicRange?.listBasicViewOther
    }
    if (listDataPublicRange?.listBasicEditCommon) {
        valueDefault.listBasicEditCommon = listDataPublicRange?.listBasicEditCommon
    }
    if (listDataPublicRange?.listBasicEditOther) {
        valueDefault.listBasicEditOther = listDataPublicRange?.listBasicEditOther
    }
    
    if (listDataPublicRange?.listAdditionalViewCommon) {
        valueDefault.listAdditionalViewCommon = listDataPublicRange?.listAdditionalViewCommon
    }
    if (listDataPublicRange?.listAdditionalViewOther) {
        valueDefault.listAdditionalViewOther = listDataPublicRange?.listAdditionalViewOther
    }
    if (listDataPublicRange?.listAdditionalEditCommon) {
        valueDefault.listAdditionalEditCommon = listDataPublicRange?.listAdditionalEditCommon
    }
    if (listDataPublicRange?.listAdditionalEditOther) {
        valueDefault.listAdditionalEditOther = listDataPublicRange?.listAdditionalEditOther
    }

    if (listDataPublicRange?.allDataAdditionalPermissionOfCorp) {
        let listAllAdditionalPermission = sortDataPermission(listDataPublicRange?.allDataAdditionalPermissionOfCorp, argsCommon?.corporationDetail);
        argsCommon?.setListAdditionalAllRole(listAllAdditionalPermission);
    }


    if (listDataPublicRange?.isHasEditPermissionSomeTicket){
        argsCommon?.setIsHasEditPermissionSomeTicket(true);
    } else {
        argsCommon?.setIsHasEditPermissionSomeTicket(false);
    }

    argsCommon?.setListDataPublicRange(valueDefault);
    localStorageUtil.setListDataPublicRangeDefault(valueDefault);

    return listDataPublicRange;
};


/**
 * permissionDuplicateTicket
 * Corp premium/guest desk On knowledge
 * prj inuse is general
 * @param {*} corporationDetail 
 * @param {*} projectInuseDetail 
 * @returns Boolean
 */
export const permissionDuplicateTicket = (corporationDetail, projectInuseDetail) => {
    if (corporationDetail.contractType === Constant.CORPORATION_CONTRACT_TYPE.GUEST) return false;
    // let knowledgeService =
    //     corporationDetail.contractType === Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK
    //         ? Utils.convertJSONDataToObject(corporationDetail?.inviterSetting)
    //               ?.usingKnowledgeService
    //         : corporationDetail.knowledgeService;

    // if (knowledgeService !== Constant.STATUS_SERVICE_PERMISSION.ON) return false;

    if (projectInuseDetail.type === Constant.PROJECT_TYPE.GENERAL) {
        return true;
    }
    return false;
};


export const addDefaultBookmarkInTicketList = async (
    ticketId,
    userId,
    projectInuseId,
    corporationInuseId,
    isBookmarkedDefaultBookmark,
    dataLog
) => {
    if (!ticketId || !userId || !projectInuseId) return;

    let addDefaultBookmarkParams = {
        action: isBookmarkedDefaultBookmark
            ? Constant.BOOKMARK_UPDATE_API_ACTION.REMOVE_DEFAULT_BOOKMARK_IN_TICKET_LIST
            : Constant.BOOKMARK_UPDATE_API_ACTION.ADD_DEFAULT_BOOKMARK_IN_TICKET_LIST,
        projectInuse: projectInuseId,
        corporationInuse: corporationInuseId,
        userId: userId,
        ticketId: ticketId,
        data: JSON.stringify({ logInfo: dataLog })
    };

    let response = await updateBookmarkAPI(addDefaultBookmarkParams);
    return response
};


/**
 * getAllPrivateBookmarkOfUserInProject
 * @param {*} userId 
 * @param {*} projectId 
 * @returns 
 */
export const getAllBookmarkUserCanUse = async (userId, projectId, targetType = Constant.BOOKMARK_TARGET_TYPE.KNOWLEDGE) => {
    if (!userId || !projectId) return [];

    let getBookmarkListParams = {
        actionType: Constant.BOOKMARK_GET_API_ACTION.GET_ALL_BOOKMARK_USER_CAN_USE_TO_BULK_ACTION,
        projectInuse: projectId,
        userId: userId,
        targetType: targetType
    };

    let response = await getBookmarkAPI(getBookmarkListParams);
    return Utils.convertJSONDataToObject(response.data);
}